/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/agents_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { AgentsServiceAssignAgentManagerBody } from '../models'
// @ts-ignore
import { AgentsServiceCloseTicketBody } from '../models'
// @ts-ignore
import { AgentsServiceCompleteAgentTaskBody } from '../models'
// @ts-ignore
import { AgentsServiceConfirmCompanyAssignmentByManagerBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateAgentTaskBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateClientCommentBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateDealCommentBody } from '../models'
// @ts-ignore
import { AgentsServiceCreateDealTaskBody } from '../models'
// @ts-ignore
import { AgentsServicePostAgentTicketMessageBody } from '../models'
// @ts-ignore
import { AgentsServiceReplyTicketBody } from '../models'
// @ts-ignore
import { AgentsServiceRequestMeetingBody } from '../models'
// @ts-ignore
import { AgentsServiceSetAgentCommercialTermsBody } from '../models'
// @ts-ignore
import { AgentsServiceSetAgentOfferStatusBody } from '../models'
// @ts-ignore
import { AgentsServiceSetAgentStatusBody } from '../models'
// @ts-ignore
import { AgentsServiceSetClientAgentBody } from '../models'
// @ts-ignore
import { AgentsServiceSetRoutingRuleEnabledBody } from '../models'
// @ts-ignore
import { AgentsServiceSharePresentationBody } from '../models'
// @ts-ignore
import { AgentsServiceTrackEducationVideoBody } from '../models'
// @ts-ignore
import { AgentsServiceUpdateMyPresentationBody } from '../models'
// @ts-ignore
import { AgentsServiceUpdatePartnerCompanyBody } from '../models'
// @ts-ignore
import { AgentsServiceUpdateRoutingRuleBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AgentClientComment } from '../models'
// @ts-ignore
import { V1AgentDealComment } from '../models'
// @ts-ignore
import { V1AgentDealTask } from '../models'
// @ts-ignore
import { V1AgentPresentation } from '../models'
// @ts-ignore
import { V1AgentProfile } from '../models'
// @ts-ignore
import { V1AgentTask } from '../models'
// @ts-ignore
import { V1AskCommissionResponse } from '../models'
// @ts-ignore
import { V1CheckLeadUniqueRequest } from '../models'
// @ts-ignore
import { V1CheckLeadUniqueResponse } from '../models'
// @ts-ignore
import { V1CompanyVerificationResponse } from '../models'
// @ts-ignore
import { V1ConfirmCompanyAssignmentByAgentRequest } from '../models'
// @ts-ignore
import { V1CreateAgentRequest } from '../models'
// @ts-ignore
import { V1CreateMyPresentationRequest } from '../models'
// @ts-ignore
import { V1CreatePartnerCompanyRequest } from '../models'
// @ts-ignore
import { V1CreateRoutingRuleRequest } from '../models'
// @ts-ignore
import { V1CreateWebinarRequest } from '../models'
// @ts-ignore
import { V1DeleteAgentBotLinkResponse } from '../models'
// @ts-ignore
import { V1GetAgentBotLinkCodeResponse } from '../models'
// @ts-ignore
import { V1GetAgentBotStatusResponse } from '../models'
// @ts-ignore
import { V1GetAgentDashboardResponse } from '../models'
// @ts-ignore
import { V1GetAgentDealsResponse } from '../models'
// @ts-ignore
import { V1GetAgentEducationProgressResponse } from '../models'
// @ts-ignore
import { V1GetAgentsWorkReportResponse } from '../models'
// @ts-ignore
import { V1GetDealFreeSlotsResponse } from '../models'
// @ts-ignore
import { V1GetEducationVideoStatsResponse } from '../models'
// @ts-ignore
import { V1GetTicketResponse } from '../models'
// @ts-ignore
import { V1ListAgentTasksResponse } from '../models'
// @ts-ignore
import { V1ListAgentsResponse } from '../models'
// @ts-ignore
import { V1ListClientCommentsResponse } from '../models'
// @ts-ignore
import { V1ListCompanyVerificationsResponse } from '../models'
// @ts-ignore
import { V1ListDealCommentsResponse } from '../models'
// @ts-ignore
import { V1ListEducationVideosResponse } from '../models'
// @ts-ignore
import { V1ListMyClientsResponse } from '../models'
// @ts-ignore
import { V1ListMyDealsResponse } from '../models'
// @ts-ignore
import { V1ListMyPresentationsResponse } from '../models'
// @ts-ignore
import { V1ListMyReferralsResponse } from '../models'
// @ts-ignore
import { V1ListPartnerCompaniesResponse } from '../models'
// @ts-ignore
import { V1ListPresentationSharesResponse } from '../models'
// @ts-ignore
import { V1ListProjectMaterialsResponse } from '../models'
// @ts-ignore
import { V1ListRoutingRulesResponse } from '../models'
// @ts-ignore
import { V1ListTicketsResponse } from '../models'
// @ts-ignore
import { V1ListWebinarsResponse } from '../models'
// @ts-ignore
import { V1OfferDocument } from '../models'
// @ts-ignore
import { V1PartnerCompanyResponse } from '../models'
// @ts-ignore
import { V1PostAgentTicketMessageResponse } from '../models'
// @ts-ignore
import { V1PresentationShare } from '../models'
// @ts-ignore
import { V1PublicPresentationResponse } from '../models'
// @ts-ignore
import { V1PublishOfferVersionRequest } from '../models'
// @ts-ignore
import { V1PublishOfferVersionResponse } from '../models'
// @ts-ignore
import { V1RegisterForWebinarResponse } from '../models'
// @ts-ignore
import { V1RegisterRequest } from '../models'
// @ts-ignore
import { V1RegisterResponse } from '../models'
// @ts-ignore
import { V1ReplyTicketResponse } from '../models'
// @ts-ignore
import { V1RequestMeetingResponse } from '../models'
// @ts-ignore
import { V1RoutingRuleResponse } from '../models'
// @ts-ignore
import { V1SearchPartnerCompaniesResponse } from '../models'
// @ts-ignore
import { V1SetClientAgentResponse } from '../models'
// @ts-ignore
import { V1SubmitInquiryRequest } from '../models'
// @ts-ignore
import { V1SubmitInquiryResponse } from '../models'
// @ts-ignore
import { V1SubmitLeadRequest } from '../models'
// @ts-ignore
import { V1SubmitLeadResponse } from '../models'
// @ts-ignore
import { V1TicketActionResponse } from '../models'
// @ts-ignore
import { V1TrackEducationVideoResponse } from '../models'
// @ts-ignore
import { V1UpdateMyProfileRequest } from '../models'
// @ts-ignore
import { V1Webinar } from '../models'
/**
 * AgentsServiceApi - axios parameter creator
 * @export
 */
export const AgentsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * Internal note: requires agents:manage.
     * @summary Archives a partner company. Companies are never deleted, because agents and deals refer to them; the built-in \"private agent\" record cannot even be archived.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceArchivePartnerCompany: async (
      id: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceArchivePartnerCompany', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceArchivePartnerCompany', 'body', body)
      const localVarPath = `/api/v1/agents/companies/{id}/archive`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Answers when the reward on one of the agent\'s deals will be paid. If the date is not settled yet, raises a request about it instead and says so.
     * @param {string} dealId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAskCommission: async (
      dealId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceAskCommission', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceAskCommission', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/commission-question`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: a manager may only take an agent for themselves; administrators and the head of sales may assign anyone.
     * @summary Puts an agent in the care of a manager, or takes them out of it.
     * @param {string} userId
     * @param {AgentsServiceAssignAgentManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAssignAgentManager: async (
      userId: string,
      body: AgentsServiceAssignAgentManagerBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceAssignAgentManager', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceAssignAgentManager', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/manager`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Answers whether a phone number belongs to a client the company already knows, before the agent submits the lead. Nothing about a matching client is revealed.
     * @param {V1CheckLeadUniqueRequest} body Phone number to check against the existing clients.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCheckLeadUnique: async (
      body: V1CheckLeadUniqueRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCheckLeadUnique', 'body', body)
      const localVarPath = `/api/v1/agents/leads/check-unique`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Closes a request, with a note about how it ended.
     * @param {string} ticketId
     * @param {AgentsServiceCloseTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCloseTicket: async (
      ticketId: string,
      body: AgentsServiceCloseTicketBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceCloseTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCloseTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/close`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:update.
     * @summary Marks a task about an agent done, or puts it back into work.
     * @param {string} userId
     * @param {string} taskId
     * @param {AgentsServiceCompleteAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCompleteAgentTask: async (
      userId: string,
      taskId: string,
      body: AgentsServiceCompleteAgentTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceCompleteAgentTask', 'userId', userId)
      // verify required parameter 'taskId' is not null or undefined
      assertParamExists('agentsServiceCompleteAgentTask', 'taskId', taskId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCompleteAgentTask', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/tasks/{taskId}/complete`
        .replace(`{${'userId'}}`, encodeURIComponent(String(userId)))
        .replace(`{${'taskId'}}`, encodeURIComponent(String(taskId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Records which of the suggested companies the agent says is theirs. A manager still confirms it afterwards.
     * @param {V1ConfirmCompanyAssignmentByAgentRequest} body Which of the suggested companies the agent says is theirs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByAgent: async (
      body: V1ConfirmCompanyAssignmentByAgentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceConfirmCompanyAssignmentByAgent', 'body', body)
      const localVarPath = `/api/v1/agents/me/company-verification/select`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Settles a company check: accepts what the agent chose, records them as a private agent, or names a different company with a reason.
     * @param {string} id
     * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByManager: async (
      id: string,
      body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceConfirmCompanyAssignmentByManager', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceConfirmCompanyAssignmentByManager', 'body', body)
      const localVarPath = `/api/v1/agents/company-verifications/{id}/confirm`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Creates an agent by hand, before they have signed up themselves: their sign-in credentials are made ready and their profile is filled in from what the manager knows. Duplicates are caught by phone, email and Telegram.
     * @param {V1CreateAgentRequest} body An agent created by hand, before they have signed up themselves.  The email address is required, because sign-in credentials are made ready for them, and a company is required as well: an agent working on their own is recorded against the built-in \&quot;private agent\&quot; company rather than against none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgent: async (
      body: V1CreateAgentRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateAgent', 'body', body)
      const localVarPath = `/api/v1/agents`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:update.
     * @summary Creates a task about an agent: a meeting, a follow-up, or something else.
     * @param {string} userId
     * @param {AgentsServiceCreateAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgentTask: async (
      userId: string,
      body: AgentsServiceCreateAgentTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceCreateAgentTask', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateAgentTask', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/tasks`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a comment from the agent to one of their own clients, and tells the manager responsible for that client about it.
     * @param {string} clientId
     * @param {AgentsServiceCreateClientCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateClientComment: async (
      clientId: string,
      body: AgentsServiceCreateClientCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('agentsServiceCreateClientComment', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateClientComment', 'body', body)
      const localVarPath = `/api/v1/agents/clients/{clientId}/comments`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a comment from the agent to one of their own deals, and tells the manager of that deal about it.
     * @param {string} dealId
     * @param {AgentsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealComment: async (
      dealId: string,
      body: AgentsServiceCreateDealCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceCreateDealComment', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateDealComment', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Books a task into a free slot of the manager of one of the agent\'s deals. A slot that has been taken in the meantime is refused rather than double-booked.
     * @param {string} dealId
     * @param {AgentsServiceCreateDealTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealTask: async (
      dealId: string,
      body: AgentsServiceCreateDealTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceCreateDealTask', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateDealTask', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/tasks`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Builds a presentation of one residential complex for the calling agent: a page they can send to a client, carrying their own business card and no company branding. The printable copy is produced afterwards.
     * @param {V1CreateMyPresentationRequest} body The presentation to build.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateMyPresentation: async (
      body: V1CreateMyPresentationRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateMyPresentation', 'body', body)
      const localVarPath = `/api/v1/agents/me/presentations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Adds a partner company to the register.
     * @param {V1CreatePartnerCompanyRequest} body A new partner company. Fields that read like enumerations are strings, and an empty one means the default named below.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreatePartnerCompany: async (
      body: V1CreatePartnerCompanyRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreatePartnerCompany', 'body', body)
      const localVarPath = `/api/v1/agents/companies`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators only.
     * @summary Adds a routing rule.
     * @param {V1CreateRoutingRuleRequest} body A new routing rule.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateRoutingRule: async (
      body: V1CreateRoutingRuleRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateRoutingRule', 'body', body)
      const localVarPath = `/api/v1/agents/routing-rules`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Publishes a webinar for agents to sign up to.
     * @param {V1CreateWebinarRequest} body A new webinar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateWebinar: async (
      body: V1CreateWebinarRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceCreateWebinar', 'body', body)
      const localVarPath = `/api/v1/agents/webinars`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Disconnects the calling agent from the Telegram bot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteAgentBotLink: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/bot-link`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a presentation. Its link stops resolving.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteMyPresentation: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceDeleteMyPresentation', 'id', id)
      const localVarPath = `/api/v1/agents/me/presentations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators only.
     * @summary Deletes a routing rule.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteRoutingRule: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceDeleteRoutingRule', 'id', id)
      const localVarPath = `/api/v1/agents/routing-rules/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note on route order: this catch-all must stay the first GET declared in the service. The gateway prepends routes as they are registered and does not prefer literal segments, so whatever is declared later matches first. Declaring the wildcard first puts it last in the chain, which is what lets the literal /agents/... routes below match at all. Never add a static GET under /agents/ above this method (DEV-509).
     * @summary Returns one agent\'s profile.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgent: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceGetAgent', 'userId', userId)
      const localVarPath = `/api/v1/agents/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a single-use code and a link that connect the calling agent to the Telegram bot.
     * @param {object} body Empty: the code is issued for the calling agent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotLinkCode: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceGetAgentBotLinkCode', 'body', body)
      const localVarPath = `/api/v1/agents/me/bot-link-code`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns whether the calling agent is connected to the Telegram bot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotStatus: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/bot-status`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the headline numbers of the calling agent\'s own dashboard: clients brought in, deals in progress, deposits paid, the forecast reward, when they last did anything and what is due next.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDashboard: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/dashboard`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: a manager sees the agents they look after, the head of sales and administrators see all of them. On route order — this wildcard must stay above the agent\'s own /agents/me/deals of the same length, or it will swallow it (DEV-509).
     * @summary Returns one agent\'s deals as staff see them: real client names, unlike the agent\'s own view, together with what has been earned and what is due.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDeals: async (
      userId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceGetAgentDeals', 'userId', userId)
      const localVarPath = `/api/v1/agents/{userId}/deals`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:read. Managers see their own agents, ADMIN and HOS see everyone.
     * @summary Returns one agent\'s progress through the training catalogue, for their card in the CRM.
     * @param {string} agentUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentEducationProgress: async (
      agentUserId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'agentUserId' is not null or undefined
      assertParamExists('agentsServiceGetAgentEducationProgress', 'agentUserId', agentUserId)
      const localVarPath = `/api/v1/agents/{agentUserId}/education/progress`.replace(
        `{${'agentUserId'}}`,
        encodeURIComponent(String(agentUserId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:read; a manager sees the agents they look after.
     * @summary Returns the work journal: every agent together with the meetings and follow-ups held with them over a period.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [periodFrom] Start of the window the meetings and follow-ups are counted over. Absent means from the beginning.  The register of agents itself is deliberately not cut by the period: a journal for one month would otherwise lose the agents signed up earlier who are exactly the ones being worked with now. When each agent first appeared is visible in their own record.
     * @param {string} [periodTo] End of that window. Absent means up to now.
     * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
     * @param {string} [agentStatus] Where the agent stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentsWorkReport: async (
      paginationPage?: string,
      paginationPerPage?: string,
      periodFrom?: string,
      periodTo?: string,
      managerId?: string,
      agentStatus?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/reports/work-journal`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['periodFrom'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['periodTo'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (agentStatus !== undefined) {
        localVarQueryParameter['agentStatus'] = agentStatus
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:read.
     * @summary Returns one company check.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetCompanyVerification: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetCompanyVerification', 'id', id)
      const localVarPath = `/api/v1/agents/company-verifications/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns when the manager of one of the agent\'s deals is free, so a meeting can be booked into a slot that is actually open.
     * @param {string} dealId
     * @param {string} [from] Start of the window. Optional.
     * @param {string} [to] End of the window. Optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetDealFreeSlots: async (
      dealId: string,
      from?: string,
      to?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceGetDealFreeSlots', 'dealId', dealId)
      const localVarPath = `/api/v1/agents/deals/{dealId}/free-slots`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Returns per-video training figures: how many agents started, how many finished, and the retention curve showing where people drop off.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetEducationVideoStats: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/education/videos/stats`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the calling agent\'s own company check: which companies were suggested for the name they typed, and where the check stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyCompanyVerification: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/company-verification`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one of the calling agent\'s presentations.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyPresentation: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetMyPresentation', 'id', id)
      const localVarPath = `/api/v1/agents/me/presentations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the profile of the agent making the call.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyProfile: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one of the calling agent\'s own requests, with the conversation about it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyTicket: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetMyTicket', 'id', id)
      const localVarPath = `/api/v1/agents/me/tickets/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Public, like registration — the offer has to be readable before signing up. Internal note: declared below the catch-all above, for the route ordering explained there.
     * @summary Returns the partnership offer: the current edition, or a named one. The language comes from the request header, falling back to Russian.
     * @param {number} [version] Zero, the default, returns the current edition. A number returns that edition, which is how an agent re-reads the one they accepted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetOffer: async (
      version?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/offer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (version !== undefined) {
        localVarQueryParameter['version'] = version
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one partner company.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPartnerCompany: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetPartnerCompany', 'id', id)
      const localVarPath = `/api/v1/agents/companies/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the presentation behind a public link, for the page a client opens. Public, and counts the view.
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPublicPresentation: async (
      token: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'token' is not null or undefined
      assertParamExists('agentsServiceGetPublicPresentation', 'token', token)
      const localVarPath = `/api/v1/agents/presentations/{token}`.replace(
        `{${'token'}}`,
        encodeURIComponent(String(token)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the same kind of code for a member of staff, so that they receive agent notifications in the bot.
     * @param {object} body Empty: the code is issued for the calling member of staff.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetStaffBotLinkCode: async (
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceGetStaffBotLinkCode', 'body', body)
      const localVarPath = `/api/v1/agents/me/staff-bot-link-code`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one request with its history and the conversation about it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetTicket: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceGetTicket', 'id', id)
      const localVarPath = `/api/v1/agents/tickets/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:read; a manager sees the agents they look after.
     * @summary Lists the tasks about one agent.
     * @param {string} userId
     * @param {string} [statusFilter] Which tasks to return: open, done, or all of them when empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgentTasks: async (
      userId: string,
      statusFilter?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceListAgentTasks', 'userId', userId)
      const localVarPath = `/api/v1/agents/{userId}/tasks`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (statusFilter !== undefined) {
        localVarQueryParameter['statusFilter'] = statusFilter
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators and the head of sales see every agent; a manager sees the ones they look after.
     * @summary Lists agents with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [searchQuery] Full-text search over the agent\&#39;s name.
     * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
     * @param {string} [country] Country of the agent, as a two-letter code.
     * @param {string} [language]
     * @param {string} [agentStatus] Where the agent stands.
     * @param {string} [companyId]
     * @param {string} [companyAssignmentStatus] How the company was decided. The requires_verification value is what \&quot;company not confirmed yet\&quot; means.
     * @param {string} [sourceGroup] Broad channel the agent came through.
     * @param {string} [registeredFrom] Only agents registered at or after this moment.
     * @param {string} [registeredTo] Only agents registered before this moment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgents: async (
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      managerId?: string,
      country?: string,
      language?: string,
      agentStatus?: string,
      companyId?: string,
      companyAssignmentStatus?: string,
      sourceGroup?: string,
      registeredFrom?: string,
      registeredTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (searchQuery !== undefined) {
        localVarQueryParameter['searchQuery'] = searchQuery
      }

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (country !== undefined) {
        localVarQueryParameter['country'] = country
      }

      if (language !== undefined) {
        localVarQueryParameter['language'] = language
      }

      if (agentStatus !== undefined) {
        localVarQueryParameter['agentStatus'] = agentStatus
      }

      if (companyId !== undefined) {
        localVarQueryParameter['companyId'] = companyId
      }

      if (companyAssignmentStatus !== undefined) {
        localVarQueryParameter['companyAssignmentStatus'] = companyAssignmentStatus
      }

      if (sourceGroup !== undefined) {
        localVarQueryParameter['sourceGroup'] = sourceGroup
      }

      if (registeredFrom !== undefined) {
        localVarQueryParameter['registeredFrom'] =
          (registeredFrom as any) instanceof Date
            ? (registeredFrom as any).toISOString()
            : registeredFrom
      }

      if (registeredTo !== undefined) {
        localVarQueryParameter['registeredTo'] =
          (registeredTo as any) instanceof Date ? (registeredTo as any).toISOString() : registeredTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the agent\'s own comments on one of their clients. Comments written by staff are not shown.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListClientComments: async (
      clientId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('agentsServiceListClientComments', 'clientId', clientId)
      const localVarPath = `/api/v1/agents/clients/{clientId}/comments`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:read.
     * @summary Lists the company checks waiting to be confirmed.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [verificationStatus] Where the check stands. Empty returns the ones waiting for a manager.
     * @param {string} [responsibleId] Manager responsible for confirming it.
     * @param {string} [agentUserId] Agent the check is about.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListCompanyVerifications: async (
      paginationPage?: string,
      paginationPerPage?: string,
      verificationStatus?: string,
      responsibleId?: string,
      agentUserId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/company-verifications`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (verificationStatus !== undefined) {
        localVarQueryParameter['verificationStatus'] = verificationStatus
      }

      if (responsibleId !== undefined) {
        localVarQueryParameter['responsibleId'] = responsibleId
      }

      if (agentUserId !== undefined) {
        localVarQueryParameter['agentUserId'] = agentUserId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the agent\'s own comments on one of their deals. Comments written by staff are not shown.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListDealComments: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceListDealComments', 'dealId', dealId)
      const localVarPath = `/api/v1/agents/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the investment strategy videos with how far the calling agent has watched each one, so the cabinet can show progress and resume playback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListEducationVideos: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/education/videos`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the clients the calling agent has brought in, with the same shortened names: where each stands and what happens next, and nothing the company keeps to itself.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyClients: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/clients`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the calling agent\'s own deals. Client names are shortened to a first name and an initial.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyDeals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the calling agent\'s presentations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyPresentations: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/presentations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the leads the calling agent has submitted, with the contact details needed to send a presentation to one of them. Only the agent\'s own leads, and only what they told the company themselves.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyReferrals: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/referrals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the calling agent\'s own requests.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [status] State of the request: new, in_progress or closed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyTickets: async (
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/tickets`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists partner companies with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [searchQuery] Full-text search over the company name.
     * @param {string} [companyStatus] State of the company.
     * @param {string} [companyType] Kind of company.
     * @param {string} [responsiblePartnerManagerId] Manager on our side responsible for the company.
     * @param {boolean} [includeArchived] Also return archived companies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPartnerCompanies: async (
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      companyStatus?: string,
      companyType?: string,
      responsiblePartnerManagerId?: string,
      includeArchived?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/companies`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (searchQuery !== undefined) {
        localVarQueryParameter['searchQuery'] = searchQuery
      }

      if (companyStatus !== undefined) {
        localVarQueryParameter['companyStatus'] = companyStatus
      }

      if (companyType !== undefined) {
        localVarQueryParameter['companyType'] = companyType
      }

      if (responsiblePartnerManagerId !== undefined) {
        localVarQueryParameter['responsiblePartnerManagerId'] = responsiblePartnerManagerId
      }

      if (includeArchived !== undefined) {
        localVarQueryParameter['includeArchived'] = includeArchived
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the per-lead links of a presentation, with how often each was opened.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPresentationShares: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceListPresentationShares', 'id', id)
      const localVarPath = `/api/v1/agents/me/presentations/{id}/shares`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the sales materials of a residential complex the agent is allowed to work with: presentations, brochures, price lists and the rest. The links are short-lived and lead straight to the file.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListProjectMaterials: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'agentsServiceListProjectMaterials',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath = `/api/v1/agents/projects/{residentialComplexId}/materials`.replace(
        `{${'residentialComplexId'}}`,
        encodeURIComponent(String(residentialComplexId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators only.
     * @summary Lists the rules that decide who answers which kind of agent request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListRoutingRules: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/routing-rules`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators and the head of sales see every request; a manager sees the ones they are responsible for, are backup for, or have taken.
     * @summary Lists agent requests with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [status] State of the request: new, in_progress or closed.
     * @param {string} [type] Kind of request.
     * @param {boolean} [assignedToMe] Only the requests the caller is responsible for, is backup for, or has taken.
     * @param {string} [agentUserId] Only the requests of this agent.
     * @param {string} [createdFrom] Only requests raised at or after this moment.
     * @param {string} [createdTo] Only requests raised before this moment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListTickets: async (
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      type?: string,
      assignedToMe?: boolean,
      agentUserId?: string,
      createdFrom?: string,
      createdTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/tickets`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      if (assignedToMe !== undefined) {
        localVarQueryParameter['assignedToMe'] = assignedToMe
      }

      if (agentUserId !== undefined) {
        localVarQueryParameter['agentUserId'] = agentUserId
      }

      if (createdFrom !== undefined) {
        localVarQueryParameter['createdFrom'] =
          (createdFrom as any) instanceof Date ? (createdFrom as any).toISOString() : createdFrom
      }

      if (createdTo !== undefined) {
        localVarQueryParameter['createdTo'] =
          (createdTo as any) instanceof Date ? (createdTo as any).toISOString() : createdTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the training webinars, with whether the calling agent signed up for each and whether they turned up.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListWebinars: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/me/webinars`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a message from the agent to the conversation about their request.
     * @param {string} ticketId
     * @param {AgentsServicePostAgentTicketMessageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePostAgentTicketMessage: async (
      ticketId: string,
      body: AgentsServicePostAgentTicketMessageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServicePostAgentTicketMessage', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServicePostAgentTicketMessage', 'body', body)
      const localVarPath = `/api/v1/agents/me/tickets/{ticketId}/messages`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Publishes an edition of the partnership offer in one language. Asking for re-acceptance moves every agent on an older edition to needing to accept the new one, in the same transaction.
     * @param {V1PublishOfferVersionRequest} body One language edition of the offer to publish. The edition number is shared across languages; each language is published separately.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePublishOfferVersion: async (
      body: V1PublishOfferVersionRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServicePublishOfferVersion', 'body', body)
      const localVarPath = `/api/v1/agents/offer/publish`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Public, and protected by a captcha instead of a token.  Input problems come back as invalid-argument errors — or already-exists when the email is taken — carrying, per field, the name of the field and a machine-readable reason code. Clients highlight the field and translate the code; the flat message is only a fallback. The codes are: INVALID_VALUE, INVALID_EMAIL, INVALID_PASSWORD, INVALID_PHONE, INVALID_COUNTRY, EMAIL_TAKEN, AGREEMENT_REQUIRED, CAPTCHA_FAILED and OFFER_VERSION_OUTDATED. Internal note: a new code is only added together with its translation key on every client (ADR-0031).
     * @summary Registers a new agent: creates their sign-in credentials, their profile and the record of their accepting the partnership offer. They can sign in once they confirm their email address.
     * @param {V1RegisterRequest} body Everything needed to sign an agent up.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegister: async (
      body: V1RegisterRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceRegister', 'body', body)
      const localVarPath = `/api/v1/agents/register`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Signs the calling agent up for a webinar.
     * @param {string} webinarId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegisterForWebinar: async (
      webinarId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'webinarId' is not null or undefined
      assertParamExists('agentsServiceRegisterForWebinar', 'webinarId', webinarId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceRegisterForWebinar', 'body', body)
      const localVarPath = `/api/v1/agents/me/webinars/{webinarId}/register`.replace(
        `{${'webinarId'}}`,
        encodeURIComponent(String(webinarId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replies to an agent in the conversation about their request, optionally taking the request at the same time.
     * @param {string} ticketId
     * @param {AgentsServiceReplyTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceReplyTicket: async (
      ticketId: string,
      body: AgentsServiceReplyTicketBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceReplyTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceReplyTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/reply`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Asks for a meeting about one of the agent\'s deals. The request goes to the manager of that deal.
     * @param {string} dealId
     * @param {AgentsServiceRequestMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRequestMeeting: async (
      dealId: string,
      body: AgentsServiceRequestMeetingBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('agentsServiceRequestMeeting', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceRequestMeeting', 'body', body)
      const localVarPath = `/api/v1/agents/deals/{dealId}/meeting`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: it has a path of its own rather than sitting under the company routes, so that the gateway does not treat it as a company identifier.
     * @summary Suggests companies by the beginning of their name, for the agency field on the sign-up form. Public, and returns only an identifier, a name and a city.
     * @param {string} [query] Beginning of the company name. At least two characters.
     * @param {number} [limit] Most suggestions to return. Zero means ten.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSearchPartnerCompanies: async (
      query?: string,
      limit?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/agents/company-search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage; special terms are recorded as approved by the caller.
     * @summary Sets how an agent is rewarded: one of the standard shares, or terms agreed specially with them.
     * @param {string} userId
     * @param {AgentsServiceSetAgentCommercialTermsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentCommercialTerms: async (
      userId: string,
      body: AgentsServiceSetAgentCommercialTermsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceSetAgentCommercialTerms', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetAgentCommercialTerms', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/commercial-terms`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Moves an agent along with respect to the partnership offer: sent, needs accepting again, rejected, suspended or not sent. Acceptance itself is recorded by the agent accepting it, never set here.
     * @param {string} userId
     * @param {AgentsServiceSetAgentOfferStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentOfferStatus: async (
      userId: string,
      body: AgentsServiceSetAgentOfferStatusBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceSetAgentOfferStatus', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetAgentOfferStatus', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/offer-status`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Moves an agent along in their life with the company: approves them, marks them dormant, or archives them. The early states are set by the sign-up and onboarding flows rather than here, and blocking is a separate matter.
     * @param {string} userId
     * @param {AgentsServiceSetAgentStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentStatus: async (
      userId: string,
      body: AgentsServiceSetAgentStatusBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'userId' is not null or undefined
      assertParamExists('agentsServiceSetAgentStatus', 'userId', userId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetAgentStatus', 'body', body)
      const localVarPath = `/api/v1/agents/{userId}/status`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: право clients:assign_agent; агент должен быть в статусе active, иначе FailedPrecondition. Снятие агента делается через client-data UpdateClient.client_source_type (DEV-1910), а не этим RPC.
     * @summary Назначает или меняет агента-источника у клиента из CRM (DEV-1912, ADR-0051): agents собирает снимки профиля агента (имя, компания, модель участия, процент вознаграждения) и передаёт их в client-data, где хранится привязка. Повтор того же агента идемпотентен: снимки обновляются, событий и уведомлений нет. Новому агенту уходит уведомление client_attached со ссылкой на карточку клиента в его кабинете.
     * @param {string} clientId
     * @param {AgentsServiceSetClientAgentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetClientAgent: async (
      clientId: string,
      body: AgentsServiceSetClientAgentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('agentsServiceSetClientAgent', 'clientId', clientId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetClientAgent', 'body', body)
      const localVarPath = `/api/v1/agents/clients/{clientId}/agent`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators only.
     * @summary Switches a routing rule on or off without deleting it.
     * @param {string} id
     * @param {AgentsServiceSetRoutingRuleEnabledBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetRoutingRuleEnabled: async (
      id: string,
      body: AgentsServiceSetRoutingRuleEnabledBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceSetRoutingRuleEnabled', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSetRoutingRuleEnabled', 'body', body)
      const localVarPath = `/api/v1/agents/routing-rules/{id}/enabled`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a link to a presentation for one particular lead, so that views can be counted per person. Sharing the same presentation with the same lead again returns the link that already exists.
     * @param {string} id
     * @param {AgentsServiceSharePresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSharePresentation: async (
      id: string,
      body: AgentsServiceSharePresentationBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceSharePresentation', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSharePresentation', 'body', body)
      const localVarPath = `/api/v1/agents/me/presentations/{id}/shares`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Raises a request that is not about any particular deal: a general question or one about how to sell. It is routed by the kind of question.
     * @param {V1SubmitInquiryRequest} body A question that is not about any particular deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitInquiry: async (
      body: V1SubmitInquiryRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSubmitInquiry', 'body', body)
      const localVarPath = `/api/v1/agents/inquiries`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Submits a lead: the agent tells the company about a client they have found, and the claim on that client is fixed for a period.
     * @param {V1SubmitLeadRequest} body The lead the agent is submitting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitLead: async (
      body: V1SubmitLeadRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceSubmitLead', 'body', body)
      const localVarPath = `/api/v1/agents/leads/submit`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Takes a request: the caller becomes the person working on it.
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTakeTicket: async (
      ticketId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceTakeTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceTakeTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/take`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Progress counts the stretches of the timeline actually played, not the cursor position: dragging the scrubber to the end does not complete a video. Stretches are clamped to the real duration, as they arrive from the browser.
     * @summary Records a batch of playback events and returns the recalculated progress.
     * @param {string} videoId
     * @param {AgentsServiceTrackEducationVideoBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTrackEducationVideo: async (
      videoId: string,
      body: AgentsServiceTrackEducationVideoBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'videoId' is not null or undefined
      assertParamExists('agentsServiceTrackEducationVideo', 'videoId', videoId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceTrackEducationVideo', 'body', body)
      const localVarPath = `/api/v1/agents/me/education/videos/{videoId}/track`.replace(
        `{${'videoId'}}`,
        encodeURIComponent(String(videoId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Passes a request on to whoever is next in line for it.
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTransferTicket: async (
      ticketId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ticketId' is not null or undefined
      assertParamExists('agentsServiceTransferTicket', 'ticketId', ticketId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceTransferTicket', 'body', body)
      const localVarPath = `/api/v1/agents/tickets/{ticketId}/transfer`.replace(
        `{${'ticketId'}}`,
        encodeURIComponent(String(ticketId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes a presentation: the complex, the language, the title or the note. The captured text and the printable copy are rebuilt, but the link stays the same, so a client who already has it sees the new version.
     * @param {string} id
     * @param {AgentsServiceUpdateMyPresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyPresentation: async (
      id: string,
      body: AgentsServiceUpdateMyPresentationBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceUpdateMyPresentation', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdateMyPresentation', 'body', body)
      const localVarPath = `/api/v1/agents/me/presentations/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Changes the parts of their own profile an agent is allowed to change: where they are, how to reach them, and their business card.
     * @param {V1UpdateMyProfileRequest} body The parts of their own profile an agent may change. An empty string leaves a field as it is.  The phone number is deliberately absent: it identifies the agent for sign-up, deduplication and routing, so changing it goes through a manager.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyProfile: async (
      body: V1UpdateMyProfileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdateMyProfile', 'body', body)
      const localVarPath = `/api/v1/agents/me`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Changes a partner company.
     * @param {string} id
     * @param {AgentsServiceUpdatePartnerCompanyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdatePartnerCompany: async (
      id: string,
      body: AgentsServiceUpdatePartnerCompanyBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceUpdatePartnerCompany', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdatePartnerCompany', 'body', body)
      const localVarPath = `/api/v1/agents/companies/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: administrators only.
     * @summary Changes a routing rule.
     * @param {string} id
     * @param {AgentsServiceUpdateRoutingRuleBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateRoutingRule: async (
      id: string,
      body: AgentsServiceUpdateRoutingRuleBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('agentsServiceUpdateRoutingRule', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('agentsServiceUpdateRoutingRule', 'body', body)
      const localVarPath = `/api/v1/agents/routing-rules/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AgentsServiceApi - functional programming interface
 * @export
 */
export const AgentsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AgentsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     * Internal note: requires agents:manage.
     * @summary Archives a partner company. Companies are never deleted, because agents and deals refer to them; the built-in \"private agent\" record cannot even be archived.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceArchivePartnerCompany(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceArchivePartnerCompany(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceArchivePartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Answers when the reward on one of the agent\'s deals will be paid. If the date is not settled yet, raises a request about it instead and says so.
     * @param {string} dealId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceAskCommission(
      dealId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AskCommissionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceAskCommission(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceAskCommission']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: a manager may only take an agent for themselves; administrators and the head of sales may assign anyone.
     * @summary Puts an agent in the care of a manager, or takes them out of it.
     * @param {string} userId
     * @param {AgentsServiceAssignAgentManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceAssignAgentManager(
      userId: string,
      body: AgentsServiceAssignAgentManagerBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceAssignAgentManager(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceAssignAgentManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Answers whether a phone number belongs to a client the company already knows, before the agent submits the lead. Nothing about a matching client is revealed.
     * @param {V1CheckLeadUniqueRequest} body Phone number to check against the existing clients.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCheckLeadUnique(
      body: V1CheckLeadUniqueRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CheckLeadUniqueResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCheckLeadUnique(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCheckLeadUnique']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Closes a request, with a note about how it ended.
     * @param {string} ticketId
     * @param {AgentsServiceCloseTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCloseTicket(
      ticketId: string,
      body: AgentsServiceCloseTicketBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TicketActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCloseTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCloseTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:update.
     * @summary Marks a task about an agent done, or puts it back into work.
     * @param {string} userId
     * @param {string} taskId
     * @param {AgentsServiceCompleteAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCompleteAgentTask(
      userId: string,
      taskId: string,
      body: AgentsServiceCompleteAgentTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCompleteAgentTask(
        userId,
        taskId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCompleteAgentTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Records which of the suggested companies the agent says is theirs. A manager still confirms it afterwards.
     * @param {V1ConfirmCompanyAssignmentByAgentRequest} body Which of the suggested companies the agent says is theirs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceConfirmCompanyAssignmentByAgent(
      body: V1ConfirmCompanyAssignmentByAgentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceConfirmCompanyAssignmentByAgent(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceConfirmCompanyAssignmentByAgent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Settles a company check: accepts what the agent chose, records them as a private agent, or names a different company with a reason.
     * @param {string} id
     * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceConfirmCompanyAssignmentByManager(
      id: string,
      body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceConfirmCompanyAssignmentByManager(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceConfirmCompanyAssignmentByManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Creates an agent by hand, before they have signed up themselves: their sign-in credentials are made ready and their profile is filled in from what the manager knows. Duplicates are caught by phone, email and Telegram.
     * @param {V1CreateAgentRequest} body An agent created by hand, before they have signed up themselves.  The email address is required, because sign-in credentials are made ready for them, and a company is required as well: an agent working on their own is recorded against the built-in \&quot;private agent\&quot; company rather than against none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateAgent(
      body: V1CreateAgentRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateAgent(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateAgent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:update.
     * @summary Creates a task about an agent: a meeting, a follow-up, or something else.
     * @param {string} userId
     * @param {AgentsServiceCreateAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateAgentTask(
      userId: string,
      body: AgentsServiceCreateAgentTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateAgentTask(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateAgentTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a comment from the agent to one of their own clients, and tells the manager responsible for that client about it.
     * @param {string} clientId
     * @param {AgentsServiceCreateClientCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateClientComment(
      clientId: string,
      body: AgentsServiceCreateClientCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentClientComment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateClientComment(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateClientComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a comment from the agent to one of their own deals, and tells the manager of that deal about it.
     * @param {string} dealId
     * @param {AgentsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateDealComment(
      dealId: string,
      body: AgentsServiceCreateDealCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentDealComment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateDealComment(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Books a task into a free slot of the manager of one of the agent\'s deals. A slot that has been taken in the meantime is refused rather than double-booked.
     * @param {string} dealId
     * @param {AgentsServiceCreateDealTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateDealTask(
      dealId: string,
      body: AgentsServiceCreateDealTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentDealTask>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateDealTask(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateDealTask']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Builds a presentation of one residential complex for the calling agent: a page they can send to a client, carrying their own business card and no company branding. The printable copy is produced afterwards.
     * @param {V1CreateMyPresentationRequest} body The presentation to build.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateMyPresentation(
      body: V1CreateMyPresentationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentPresentation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateMyPresentation(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Adds a partner company to the register.
     * @param {V1CreatePartnerCompanyRequest} body A new partner company. Fields that read like enumerations are strings, and an empty one means the default named below.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreatePartnerCompany(
      body: V1CreatePartnerCompanyRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreatePartnerCompany(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreatePartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators only.
     * @summary Adds a routing rule.
     * @param {V1CreateRoutingRuleRequest} body A new routing rule.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateRoutingRule(
      body: V1CreateRoutingRuleRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RoutingRuleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateRoutingRule(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateRoutingRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Publishes a webinar for agents to sign up to.
     * @param {V1CreateWebinarRequest} body A new webinar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceCreateWebinar(
      body: V1CreateWebinarRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1Webinar>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceCreateWebinar(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceCreateWebinar']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Disconnects the calling agent from the Telegram bot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceDeleteAgentBotLink(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DeleteAgentBotLinkResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceDeleteAgentBotLink(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceDeleteAgentBotLink']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a presentation. Its link stops resolving.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceDeleteMyPresentation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceDeleteMyPresentation(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceDeleteMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators only.
     * @summary Deletes a routing rule.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceDeleteRoutingRule(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceDeleteRoutingRule(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceDeleteRoutingRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note on route order: this catch-all must stay the first GET declared in the service. The gateway prepends routes as they are registered and does not prefer literal segments, so whatever is declared later matches first. Declaring the wildcard first puts it last in the chain, which is what lets the literal /agents/... routes below match at all. Never add a static GET under /agents/ above this method (DEV-509).
     * @summary Returns one agent\'s profile.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgent(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgent(
        userId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgent']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a single-use code and a link that connect the calling agent to the Telegram bot.
     * @param {object} body Empty: the code is issued for the calling agent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentBotLinkCode(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentBotLinkCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgentBotLinkCode(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentBotLinkCode']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns whether the calling agent is connected to the Telegram bot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentBotStatus(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentBotStatusResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetAgentBotStatus(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentBotStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the headline numbers of the calling agent\'s own dashboard: clients brought in, deals in progress, deposits paid, the forecast reward, when they last did anything and what is due next.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentDashboard(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentDashboardResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetAgentDashboard(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentDashboard']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: a manager sees the agents they look after, the head of sales and administrators see all of them. On route order — this wildcard must stay above the agent\'s own /agents/me/deals of the same length, or it will swallow it (DEV-509).
     * @summary Returns one agent\'s deals as staff see them: real client names, unlike the agent\'s own view, together with what has been earned and what is due.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentDeals(
      userId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentDealsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgentDeals(
        userId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentDeals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:read. Managers see their own agents, ADMIN and HOS see everyone.
     * @summary Returns one agent\'s progress through the training catalogue, for their card in the CRM.
     * @param {string} agentUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentEducationProgress(
      agentUserId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetAgentEducationProgressResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetAgentEducationProgress(agentUserId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentEducationProgress']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:read; a manager sees the agents they look after.
     * @summary Returns the work journal: every agent together with the meetings and follow-ups held with them over a period.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [periodFrom] Start of the window the meetings and follow-ups are counted over. Absent means from the beginning.  The register of agents itself is deliberately not cut by the period: a journal for one month would otherwise lose the agents signed up earlier who are exactly the ones being worked with now. When each agent first appeared is visible in their own record.
     * @param {string} [periodTo] End of that window. Absent means up to now.
     * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
     * @param {string} [agentStatus] Where the agent stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetAgentsWorkReport(
      paginationPage?: string,
      paginationPerPage?: string,
      periodFrom?: string,
      periodTo?: string,
      managerId?: string,
      agentStatus?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentsWorkReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetAgentsWorkReport(
        paginationPage,
        paginationPerPage,
        periodFrom,
        periodTo,
        managerId,
        agentStatus,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetAgentsWorkReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:read.
     * @summary Returns one company check.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetCompanyVerification(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetCompanyVerification(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetCompanyVerification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns when the manager of one of the agent\'s deals is free, so a meeting can be booked into a slot that is actually open.
     * @param {string} dealId
     * @param {string} [from] Start of the window. Optional.
     * @param {string} [to] End of the window. Optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetDealFreeSlots(
      dealId: string,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealFreeSlotsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetDealFreeSlots(
        dealId,
        from,
        to,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetDealFreeSlots']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Returns per-video training figures: how many agents started, how many finished, and the retention curve showing where people drop off.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetEducationVideoStats(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetEducationVideoStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetEducationVideoStats(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetEducationVideoStats']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the calling agent\'s own company check: which companies were suggested for the name they typed, and where the check stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyCompanyVerification(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CompanyVerificationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceGetMyCompanyVerification(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyCompanyVerification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one of the calling agent\'s presentations.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyPresentation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentPresentation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetMyPresentation(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the profile of the agent making the call.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyProfile(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetMyProfile(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyProfile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one of the calling agent\'s own requests, with the conversation about it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetMyTicket(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetTicketResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetMyTicket(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetMyTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Public, like registration — the offer has to be readable before signing up. Internal note: declared below the catch-all above, for the route ordering explained there.
     * @summary Returns the partnership offer: the current edition, or a named one. The language comes from the request header, falling back to Russian.
     * @param {number} [version] Zero, the default, returns the current edition. A number returns that edition, which is how an agent re-reads the one they accepted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetOffer(
      version?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1OfferDocument>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetOffer(
        version,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetOffer']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one partner company.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetPartnerCompany(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetPartnerCompany(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetPartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the presentation behind a public link, for the page a client opens. Public, and counts the view.
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetPublicPresentation(
      token: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublicPresentationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetPublicPresentation(
        token,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetPublicPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the same kind of code for a member of staff, so that they receive agent notifications in the bot.
     * @param {object} body Empty: the code is issued for the calling member of staff.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetStaffBotLinkCode(
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentBotLinkCodeResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetStaffBotLinkCode(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetStaffBotLinkCode']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one request with its history and the conversation about it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceGetTicket(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetTicketResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceGetTicket(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceGetTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:read; a manager sees the agents they look after.
     * @summary Lists the tasks about one agent.
     * @param {string} userId
     * @param {string} [statusFilter] Which tasks to return: open, done, or all of them when empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListAgentTasks(
      userId: string,
      statusFilter?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListAgentTasksResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListAgentTasks(
        userId,
        statusFilter,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListAgentTasks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators and the head of sales see every agent; a manager sees the ones they look after.
     * @summary Lists agents with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [searchQuery] Full-text search over the agent\&#39;s name.
     * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
     * @param {string} [country] Country of the agent, as a two-letter code.
     * @param {string} [language]
     * @param {string} [agentStatus] Where the agent stands.
     * @param {string} [companyId]
     * @param {string} [companyAssignmentStatus] How the company was decided. The requires_verification value is what \&quot;company not confirmed yet\&quot; means.
     * @param {string} [sourceGroup] Broad channel the agent came through.
     * @param {string} [registeredFrom] Only agents registered at or after this moment.
     * @param {string} [registeredTo] Only agents registered before this moment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListAgents(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      managerId?: string,
      country?: string,
      language?: string,
      agentStatus?: string,
      companyId?: string,
      companyAssignmentStatus?: string,
      sourceGroup?: string,
      registeredFrom?: string,
      registeredTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListAgentsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListAgents(
        paginationPage,
        paginationPerPage,
        searchQuery,
        managerId,
        country,
        language,
        agentStatus,
        companyId,
        companyAssignmentStatus,
        sourceGroup,
        registeredFrom,
        registeredTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListAgents']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the agent\'s own comments on one of their clients. Comments written by staff are not shown.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListClientComments(
      clientId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListClientCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListClientComments(
        clientId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListClientComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:read.
     * @summary Lists the company checks waiting to be confirmed.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [verificationStatus] Where the check stands. Empty returns the ones waiting for a manager.
     * @param {string} [responsibleId] Manager responsible for confirming it.
     * @param {string} [agentUserId] Agent the check is about.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListCompanyVerifications(
      paginationPage?: string,
      paginationPerPage?: string,
      verificationStatus?: string,
      responsibleId?: string,
      agentUserId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListCompanyVerificationsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListCompanyVerifications(
          paginationPage,
          paginationPerPage,
          verificationStatus,
          responsibleId,
          agentUserId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListCompanyVerifications']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the agent\'s own comments on one of their deals. Comments written by staff are not shown.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListDealComments(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListDealComments(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListDealComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the investment strategy videos with how far the calling agent has watched each one, so the cabinet can show progress and resume playback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListEducationVideos(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListEducationVideosResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListEducationVideos(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListEducationVideos']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the clients the calling agent has brought in, with the same shortened names: where each stands and what happens next, and nothing the company keeps to itself.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyClients(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyClientsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListMyClients(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyClients']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the calling agent\'s own deals. Client names are shortened to a first name and an initial.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyDeals(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyDealsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListMyDeals(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyDeals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the calling agent\'s presentations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyPresentations(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyPresentationsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListMyPresentations(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyPresentations']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the leads the calling agent has submitted, with the contact details needed to send a presentation to one of them. Only the agent\'s own leads, and only what they told the company themselves.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyReferrals(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListMyReferralsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListMyReferrals(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyReferrals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the calling agent\'s own requests.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [status] State of the request: new, in_progress or closed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListMyTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTicketsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListMyTickets(
        paginationPage,
        paginationPerPage,
        status,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListMyTickets']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists partner companies with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [searchQuery] Full-text search over the company name.
     * @param {string} [companyStatus] State of the company.
     * @param {string} [companyType] Kind of company.
     * @param {string} [responsiblePartnerManagerId] Manager on our side responsible for the company.
     * @param {boolean} [includeArchived] Also return archived companies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListPartnerCompanies(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      companyStatus?: string,
      companyType?: string,
      responsiblePartnerManagerId?: string,
      includeArchived?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPartnerCompaniesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListPartnerCompanies(
        paginationPage,
        paginationPerPage,
        searchQuery,
        companyStatus,
        companyType,
        responsiblePartnerManagerId,
        includeArchived,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListPartnerCompanies']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the per-lead links of a presentation, with how often each was opened.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListPresentationShares(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListPresentationSharesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListPresentationShares(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListPresentationShares']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the sales materials of a residential complex the agent is allowed to work with: presentations, brochures, price lists and the rest. The links are short-lived and lead straight to the file.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListProjectMaterials(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListProjectMaterialsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListProjectMaterials(
        residentialComplexId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListProjectMaterials']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators only.
     * @summary Lists the rules that decide who answers which kind of agent request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListRoutingRules(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListRoutingRulesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceListRoutingRules(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListRoutingRules']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators and the head of sales see every request; a manager sees the ones they are responsible for, are backup for, or have taken.
     * @summary Lists agent requests with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [status] State of the request: new, in_progress or closed.
     * @param {string} [type] Kind of request.
     * @param {boolean} [assignedToMe] Only the requests the caller is responsible for, is backup for, or has taken.
     * @param {string} [agentUserId] Only the requests of this agent.
     * @param {string} [createdFrom] Only requests raised at or after this moment.
     * @param {string} [createdTo] Only requests raised before this moment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      type?: string,
      assignedToMe?: boolean,
      agentUserId?: string,
      createdFrom?: string,
      createdTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTicketsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListTickets(
        paginationPage,
        paginationPerPage,
        status,
        type,
        assignedToMe,
        agentUserId,
        createdFrom,
        createdTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListTickets']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the training webinars, with whether the calling agent signed up for each and whether they turned up.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceListWebinars(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListWebinarsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceListWebinars(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceListWebinars']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a message from the agent to the conversation about their request.
     * @param {string} ticketId
     * @param {AgentsServicePostAgentTicketMessageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServicePostAgentTicketMessage(
      ticketId: string,
      body: AgentsServicePostAgentTicketMessageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PostAgentTicketMessageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServicePostAgentTicketMessage(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServicePostAgentTicketMessage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Publishes an edition of the partnership offer in one language. Asking for re-acceptance moves every agent on an older edition to needing to accept the new one, in the same transaction.
     * @param {V1PublishOfferVersionRequest} body One language edition of the offer to publish. The edition number is shared across languages; each language is published separately.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServicePublishOfferVersion(
      body: V1PublishOfferVersionRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PublishOfferVersionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServicePublishOfferVersion(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServicePublishOfferVersion']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Public, and protected by a captcha instead of a token.  Input problems come back as invalid-argument errors — or already-exists when the email is taken — carrying, per field, the name of the field and a machine-readable reason code. Clients highlight the field and translate the code; the flat message is only a fallback. The codes are: INVALID_VALUE, INVALID_EMAIL, INVALID_PASSWORD, INVALID_PHONE, INVALID_COUNTRY, EMAIL_TAKEN, AGREEMENT_REQUIRED, CAPTCHA_FAILED and OFFER_VERSION_OUTDATED. Internal note: a new code is only added together with its translation key on every client (ADR-0031).
     * @summary Registers a new agent: creates their sign-in credentials, their profile and the record of their accepting the partnership offer. They can sign in once they confirm their email address.
     * @param {V1RegisterRequest} body Everything needed to sign an agent up.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceRegister(
      body: V1RegisterRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RegisterResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceRegister(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceRegister']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Signs the calling agent up for a webinar.
     * @param {string} webinarId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceRegisterForWebinar(
      webinarId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RegisterForWebinarResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceRegisterForWebinar(
        webinarId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceRegisterForWebinar']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replies to an agent in the conversation about their request, optionally taking the request at the same time.
     * @param {string} ticketId
     * @param {AgentsServiceReplyTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceReplyTicket(
      ticketId: string,
      body: AgentsServiceReplyTicketBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ReplyTicketResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceReplyTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceReplyTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Asks for a meeting about one of the agent\'s deals. The request goes to the manager of that deal.
     * @param {string} dealId
     * @param {AgentsServiceRequestMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceRequestMeeting(
      dealId: string,
      body: AgentsServiceRequestMeetingBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RequestMeetingResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceRequestMeeting(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceRequestMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: it has a path of its own rather than sitting under the company routes, so that the gateway does not treat it as a company identifier.
     * @summary Suggests companies by the beginning of their name, for the agency field on the sign-up form. Public, and returns only an identifier, a name and a city.
     * @param {string} [query] Beginning of the company name. At least two characters.
     * @param {number} [limit] Most suggestions to return. Zero means ten.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSearchPartnerCompanies(
      query?: string,
      limit?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchPartnerCompaniesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSearchPartnerCompanies(
        query,
        limit,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSearchPartnerCompanies']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage; special terms are recorded as approved by the caller.
     * @summary Sets how an agent is rewarded: one of the standard shares, or terms agreed specially with them.
     * @param {string} userId
     * @param {AgentsServiceSetAgentCommercialTermsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetAgentCommercialTerms(
      userId: string,
      body: AgentsServiceSetAgentCommercialTermsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.agentsServiceSetAgentCommercialTerms(userId, body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetAgentCommercialTerms']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Moves an agent along with respect to the partnership offer: sent, needs accepting again, rejected, suspended or not sent. Acceptance itself is recorded by the agent accepting it, never set here.
     * @param {string} userId
     * @param {AgentsServiceSetAgentOfferStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetAgentOfferStatus(
      userId: string,
      body: AgentsServiceSetAgentOfferStatusBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetAgentOfferStatus(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetAgentOfferStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Moves an agent along in their life with the company: approves them, marks them dormant, or archives them. The early states are set by the sign-up and onboarding flows rather than here, and blocking is a separate matter.
     * @param {string} userId
     * @param {AgentsServiceSetAgentStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetAgentStatus(
      userId: string,
      body: AgentsServiceSetAgentStatusBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetAgentStatus(
        userId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetAgentStatus']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: право clients:assign_agent; агент должен быть в статусе active, иначе FailedPrecondition. Снятие агента делается через client-data UpdateClient.client_source_type (DEV-1910), а не этим RPC.
     * @summary Назначает или меняет агента-источника у клиента из CRM (DEV-1912, ADR-0051): agents собирает снимки профиля агента (имя, компания, модель участия, процент вознаграждения) и передаёт их в client-data, где хранится привязка. Повтор того же агента идемпотентен: снимки обновляются, событий и уведомлений нет. Новому агенту уходит уведомление client_attached со ссылкой на карточку клиента в его кабинете.
     * @param {string} clientId
     * @param {AgentsServiceSetClientAgentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetClientAgent(
      clientId: string,
      body: AgentsServiceSetClientAgentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SetClientAgentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetClientAgent(
        clientId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetClientAgent']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators only.
     * @summary Switches a routing rule on or off without deleting it.
     * @param {string} id
     * @param {AgentsServiceSetRoutingRuleEnabledBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSetRoutingRuleEnabled(
      id: string,
      body: AgentsServiceSetRoutingRuleEnabledBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RoutingRuleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSetRoutingRuleEnabled(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSetRoutingRuleEnabled']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a link to a presentation for one particular lead, so that views can be counted per person. Sharing the same presentation with the same lead again returns the link that already exists.
     * @param {string} id
     * @param {AgentsServiceSharePresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSharePresentation(
      id: string,
      body: AgentsServiceSharePresentationBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PresentationShare>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSharePresentation(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSharePresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Raises a request that is not about any particular deal: a general question or one about how to sell. It is routed by the kind of question.
     * @param {V1SubmitInquiryRequest} body A question that is not about any particular deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSubmitInquiry(
      body: V1SubmitInquiryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SubmitInquiryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSubmitInquiry(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSubmitInquiry']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Submits a lead: the agent tells the company about a client they have found, and the claim on that client is fixed for a period.
     * @param {V1SubmitLeadRequest} body The lead the agent is submitting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceSubmitLead(
      body: V1SubmitLeadRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SubmitLeadResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceSubmitLead(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceSubmitLead']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Takes a request: the caller becomes the person working on it.
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceTakeTicket(
      ticketId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TicketActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceTakeTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceTakeTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Progress counts the stretches of the timeline actually played, not the cursor position: dragging the scrubber to the end does not complete a video. Stretches are clamped to the real duration, as they arrive from the browser.
     * @summary Records a batch of playback events and returns the recalculated progress.
     * @param {string} videoId
     * @param {AgentsServiceTrackEducationVideoBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceTrackEducationVideo(
      videoId: string,
      body: AgentsServiceTrackEducationVideoBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TrackEducationVideoResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceTrackEducationVideo(
        videoId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceTrackEducationVideo']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Passes a request on to whoever is next in line for it.
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceTransferTicket(
      ticketId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1TicketActionResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceTransferTicket(
        ticketId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceTransferTicket']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes a presentation: the complex, the language, the title or the note. The captured text and the printable copy are rebuilt, but the link stays the same, so a client who already has it sees the new version.
     * @param {string} id
     * @param {AgentsServiceUpdateMyPresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdateMyPresentation(
      id: string,
      body: AgentsServiceUpdateMyPresentationBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentPresentation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdateMyPresentation(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdateMyPresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Changes the parts of their own profile an agent is allowed to change: where they are, how to reach them, and their business card.
     * @param {V1UpdateMyProfileRequest} body The parts of their own profile an agent may change. An empty string leaves a field as it is.  The phone number is deliberately absent: it identifies the agent for sign-up, deduplication and routing, so changing it goes through a manager.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdateMyProfile(
      body: V1UpdateMyProfileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AgentProfile>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdateMyProfile(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdateMyProfile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Changes a partner company.
     * @param {string} id
     * @param {AgentsServiceUpdatePartnerCompanyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdatePartnerCompany(
      id: string,
      body: AgentsServiceUpdatePartnerCompanyBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PartnerCompanyResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdatePartnerCompany(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdatePartnerCompany']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: administrators only.
     * @summary Changes a routing rule.
     * @param {string} id
     * @param {AgentsServiceUpdateRoutingRuleBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async agentsServiceUpdateRoutingRule(
      id: string,
      body: AgentsServiceUpdateRoutingRuleBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RoutingRuleResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.agentsServiceUpdateRoutingRule(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AgentsServiceApi.agentsServiceUpdateRoutingRule']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AgentsServiceApi - factory interface
 * @export
 */
export const AgentsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AgentsServiceApiFp(configuration)
  return {
    /**
     * Internal note: requires agents:manage.
     * @summary Archives a partner company. Companies are never deleted, because agents and deals refer to them; the built-in \"private agent\" record cannot even be archived.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceArchivePartnerCompany(
      id: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceArchivePartnerCompany(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Answers when the reward on one of the agent\'s deals will be paid. If the date is not settled yet, raises a request about it instead and says so.
     * @param {string} dealId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAskCommission(
      dealId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1AskCommissionResponse> {
      return localVarFp
        .agentsServiceAskCommission(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: a manager may only take an agent for themselves; administrators and the head of sales may assign anyone.
     * @summary Puts an agent in the care of a manager, or takes them out of it.
     * @param {string} userId
     * @param {AgentsServiceAssignAgentManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceAssignAgentManager(
      userId: string,
      body: AgentsServiceAssignAgentManagerBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceAssignAgentManager(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Answers whether a phone number belongs to a client the company already knows, before the agent submits the lead. Nothing about a matching client is revealed.
     * @param {V1CheckLeadUniqueRequest} body Phone number to check against the existing clients.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCheckLeadUnique(
      body: V1CheckLeadUniqueRequest,
      options?: any,
    ): AxiosPromise<V1CheckLeadUniqueResponse> {
      return localVarFp
        .agentsServiceCheckLeadUnique(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Closes a request, with a note about how it ended.
     * @param {string} ticketId
     * @param {AgentsServiceCloseTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCloseTicket(
      ticketId: string,
      body: AgentsServiceCloseTicketBody,
      options?: any,
    ): AxiosPromise<V1TicketActionResponse> {
      return localVarFp
        .agentsServiceCloseTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:update.
     * @summary Marks a task about an agent done, or puts it back into work.
     * @param {string} userId
     * @param {string} taskId
     * @param {AgentsServiceCompleteAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCompleteAgentTask(
      userId: string,
      taskId: string,
      body: AgentsServiceCompleteAgentTaskBody,
      options?: any,
    ): AxiosPromise<V1AgentTask> {
      return localVarFp
        .agentsServiceCompleteAgentTask(userId, taskId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Records which of the suggested companies the agent says is theirs. A manager still confirms it afterwards.
     * @param {V1ConfirmCompanyAssignmentByAgentRequest} body Which of the suggested companies the agent says is theirs.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByAgent(
      body: V1ConfirmCompanyAssignmentByAgentRequest,
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceConfirmCompanyAssignmentByAgent(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Settles a company check: accepts what the agent chose, records them as a private agent, or names a different company with a reason.
     * @param {string} id
     * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceConfirmCompanyAssignmentByManager(
      id: string,
      body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceConfirmCompanyAssignmentByManager(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Creates an agent by hand, before they have signed up themselves: their sign-in credentials are made ready and their profile is filled in from what the manager knows. Duplicates are caught by phone, email and Telegram.
     * @param {V1CreateAgentRequest} body An agent created by hand, before they have signed up themselves.  The email address is required, because sign-in credentials are made ready for them, and a company is required as well: an agent working on their own is recorded against the built-in \&quot;private agent\&quot; company rather than against none.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgent(
      body: V1CreateAgentRequest,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceCreateAgent(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:update.
     * @summary Creates a task about an agent: a meeting, a follow-up, or something else.
     * @param {string} userId
     * @param {AgentsServiceCreateAgentTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateAgentTask(
      userId: string,
      body: AgentsServiceCreateAgentTaskBody,
      options?: any,
    ): AxiosPromise<V1AgentTask> {
      return localVarFp
        .agentsServiceCreateAgentTask(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a comment from the agent to one of their own clients, and tells the manager responsible for that client about it.
     * @param {string} clientId
     * @param {AgentsServiceCreateClientCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateClientComment(
      clientId: string,
      body: AgentsServiceCreateClientCommentBody,
      options?: any,
    ): AxiosPromise<V1AgentClientComment> {
      return localVarFp
        .agentsServiceCreateClientComment(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a comment from the agent to one of their own deals, and tells the manager of that deal about it.
     * @param {string} dealId
     * @param {AgentsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealComment(
      dealId: string,
      body: AgentsServiceCreateDealCommentBody,
      options?: any,
    ): AxiosPromise<V1AgentDealComment> {
      return localVarFp
        .agentsServiceCreateDealComment(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Books a task into a free slot of the manager of one of the agent\'s deals. A slot that has been taken in the meantime is refused rather than double-booked.
     * @param {string} dealId
     * @param {AgentsServiceCreateDealTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateDealTask(
      dealId: string,
      body: AgentsServiceCreateDealTaskBody,
      options?: any,
    ): AxiosPromise<V1AgentDealTask> {
      return localVarFp
        .agentsServiceCreateDealTask(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Builds a presentation of one residential complex for the calling agent: a page they can send to a client, carrying their own business card and no company branding. The printable copy is produced afterwards.
     * @param {V1CreateMyPresentationRequest} body The presentation to build.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateMyPresentation(
      body: V1CreateMyPresentationRequest,
      options?: any,
    ): AxiosPromise<V1AgentPresentation> {
      return localVarFp
        .agentsServiceCreateMyPresentation(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Adds a partner company to the register.
     * @param {V1CreatePartnerCompanyRequest} body A new partner company. Fields that read like enumerations are strings, and an empty one means the default named below.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreatePartnerCompany(
      body: V1CreatePartnerCompanyRequest,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceCreatePartnerCompany(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators only.
     * @summary Adds a routing rule.
     * @param {V1CreateRoutingRuleRequest} body A new routing rule.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateRoutingRule(
      body: V1CreateRoutingRuleRequest,
      options?: any,
    ): AxiosPromise<V1RoutingRuleResponse> {
      return localVarFp
        .agentsServiceCreateRoutingRule(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Publishes a webinar for agents to sign up to.
     * @param {V1CreateWebinarRequest} body A new webinar.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceCreateWebinar(
      body: V1CreateWebinarRequest,
      options?: any,
    ): AxiosPromise<V1Webinar> {
      return localVarFp
        .agentsServiceCreateWebinar(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Disconnects the calling agent from the Telegram bot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteAgentBotLink(options?: any): AxiosPromise<V1DeleteAgentBotLinkResponse> {
      return localVarFp
        .agentsServiceDeleteAgentBotLink(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a presentation. Its link stops resolving.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteMyPresentation(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .agentsServiceDeleteMyPresentation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators only.
     * @summary Deletes a routing rule.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceDeleteRoutingRule(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .agentsServiceDeleteRoutingRule(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note on route order: this catch-all must stay the first GET declared in the service. The gateway prepends routes as they are registered and does not prefer literal segments, so whatever is declared later matches first. Declaring the wildcard first puts it last in the chain, which is what lets the literal /agents/... routes below match at all. Never add a static GET under /agents/ above this method (DEV-509).
     * @summary Returns one agent\'s profile.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgent(userId: string, options?: any): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceGetAgent(userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a single-use code and a link that connect the calling agent to the Telegram bot.
     * @param {object} body Empty: the code is issued for the calling agent.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotLinkCode(
      body: object,
      options?: any,
    ): AxiosPromise<V1GetAgentBotLinkCodeResponse> {
      return localVarFp
        .agentsServiceGetAgentBotLinkCode(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns whether the calling agent is connected to the Telegram bot.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentBotStatus(options?: any): AxiosPromise<V1GetAgentBotStatusResponse> {
      return localVarFp
        .agentsServiceGetAgentBotStatus(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the headline numbers of the calling agent\'s own dashboard: clients brought in, deals in progress, deposits paid, the forecast reward, when they last did anything and what is due next.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDashboard(options?: any): AxiosPromise<V1GetAgentDashboardResponse> {
      return localVarFp
        .agentsServiceGetAgentDashboard(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: a manager sees the agents they look after, the head of sales and administrators see all of them. On route order — this wildcard must stay above the agent\'s own /agents/me/deals of the same length, or it will swallow it (DEV-509).
     * @summary Returns one agent\'s deals as staff see them: real client names, unlike the agent\'s own view, together with what has been earned and what is due.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentDeals(
      userId: string,
      options?: any,
    ): AxiosPromise<V1GetAgentDealsResponse> {
      return localVarFp
        .agentsServiceGetAgentDeals(userId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:read. Managers see their own agents, ADMIN and HOS see everyone.
     * @summary Returns one agent\'s progress through the training catalogue, for their card in the CRM.
     * @param {string} agentUserId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentEducationProgress(
      agentUserId: string,
      options?: any,
    ): AxiosPromise<V1GetAgentEducationProgressResponse> {
      return localVarFp
        .agentsServiceGetAgentEducationProgress(agentUserId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:read; a manager sees the agents they look after.
     * @summary Returns the work journal: every agent together with the meetings and follow-ups held with them over a period.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [periodFrom] Start of the window the meetings and follow-ups are counted over. Absent means from the beginning.  The register of agents itself is deliberately not cut by the period: a journal for one month would otherwise lose the agents signed up earlier who are exactly the ones being worked with now. When each agent first appeared is visible in their own record.
     * @param {string} [periodTo] End of that window. Absent means up to now.
     * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
     * @param {string} [agentStatus] Where the agent stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetAgentsWorkReport(
      paginationPage?: string,
      paginationPerPage?: string,
      periodFrom?: string,
      periodTo?: string,
      managerId?: string,
      agentStatus?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentsWorkReportResponse> {
      return localVarFp
        .agentsServiceGetAgentsWorkReport(
          paginationPage,
          paginationPerPage,
          periodFrom,
          periodTo,
          managerId,
          agentStatus,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:read.
     * @summary Returns one company check.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetCompanyVerification(
      id: string,
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceGetCompanyVerification(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns when the manager of one of the agent\'s deals is free, so a meeting can be booked into a slot that is actually open.
     * @param {string} dealId
     * @param {string} [from] Start of the window. Optional.
     * @param {string} [to] End of the window. Optional.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetDealFreeSlots(
      dealId: string,
      from?: string,
      to?: string,
      options?: any,
    ): AxiosPromise<V1GetDealFreeSlotsResponse> {
      return localVarFp
        .agentsServiceGetDealFreeSlots(dealId, from, to, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Returns per-video training figures: how many agents started, how many finished, and the retention curve showing where people drop off.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetEducationVideoStats(
      options?: any,
    ): AxiosPromise<V1GetEducationVideoStatsResponse> {
      return localVarFp
        .agentsServiceGetEducationVideoStats(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the calling agent\'s own company check: which companies were suggested for the name they typed, and where the check stands.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyCompanyVerification(
      options?: any,
    ): AxiosPromise<V1CompanyVerificationResponse> {
      return localVarFp
        .agentsServiceGetMyCompanyVerification(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one of the calling agent\'s presentations.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyPresentation(id: string, options?: any): AxiosPromise<V1AgentPresentation> {
      return localVarFp
        .agentsServiceGetMyPresentation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the profile of the agent making the call.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyProfile(options?: any): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceGetMyProfile(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one of the calling agent\'s own requests, with the conversation about it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetMyTicket(id: string, options?: any): AxiosPromise<V1GetTicketResponse> {
      return localVarFp
        .agentsServiceGetMyTicket(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Public, like registration — the offer has to be readable before signing up. Internal note: declared below the catch-all above, for the route ordering explained there.
     * @summary Returns the partnership offer: the current edition, or a named one. The language comes from the request header, falling back to Russian.
     * @param {number} [version] Zero, the default, returns the current edition. A number returns that edition, which is how an agent re-reads the one they accepted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetOffer(version?: number, options?: any): AxiosPromise<V1OfferDocument> {
      return localVarFp
        .agentsServiceGetOffer(version, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one partner company.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPartnerCompany(
      id: string,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceGetPartnerCompany(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the presentation behind a public link, for the page a client opens. Public, and counts the view.
     * @param {string} token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetPublicPresentation(
      token: string,
      options?: any,
    ): AxiosPromise<V1PublicPresentationResponse> {
      return localVarFp
        .agentsServiceGetPublicPresentation(token, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the same kind of code for a member of staff, so that they receive agent notifications in the bot.
     * @param {object} body Empty: the code is issued for the calling member of staff.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetStaffBotLinkCode(
      body: object,
      options?: any,
    ): AxiosPromise<V1GetAgentBotLinkCodeResponse> {
      return localVarFp
        .agentsServiceGetStaffBotLinkCode(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one request with its history and the conversation about it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceGetTicket(id: string, options?: any): AxiosPromise<V1GetTicketResponse> {
      return localVarFp
        .agentsServiceGetTicket(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:read; a manager sees the agents they look after.
     * @summary Lists the tasks about one agent.
     * @param {string} userId
     * @param {string} [statusFilter] Which tasks to return: open, done, or all of them when empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgentTasks(
      userId: string,
      statusFilter?: string,
      options?: any,
    ): AxiosPromise<V1ListAgentTasksResponse> {
      return localVarFp
        .agentsServiceListAgentTasks(userId, statusFilter, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators and the head of sales see every agent; a manager sees the ones they look after.
     * @summary Lists agents with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [searchQuery] Full-text search over the agent\&#39;s name.
     * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
     * @param {string} [country] Country of the agent, as a two-letter code.
     * @param {string} [language]
     * @param {string} [agentStatus] Where the agent stands.
     * @param {string} [companyId]
     * @param {string} [companyAssignmentStatus] How the company was decided. The requires_verification value is what \&quot;company not confirmed yet\&quot; means.
     * @param {string} [sourceGroup] Broad channel the agent came through.
     * @param {string} [registeredFrom] Only agents registered at or after this moment.
     * @param {string} [registeredTo] Only agents registered before this moment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListAgents(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      managerId?: string,
      country?: string,
      language?: string,
      agentStatus?: string,
      companyId?: string,
      companyAssignmentStatus?: string,
      sourceGroup?: string,
      registeredFrom?: string,
      registeredTo?: string,
      options?: any,
    ): AxiosPromise<V1ListAgentsResponse> {
      return localVarFp
        .agentsServiceListAgents(
          paginationPage,
          paginationPerPage,
          searchQuery,
          managerId,
          country,
          language,
          agentStatus,
          companyId,
          companyAssignmentStatus,
          sourceGroup,
          registeredFrom,
          registeredTo,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the agent\'s own comments on one of their clients. Comments written by staff are not shown.
     * @param {string} clientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListClientComments(
      clientId: string,
      options?: any,
    ): AxiosPromise<V1ListClientCommentsResponse> {
      return localVarFp
        .agentsServiceListClientComments(clientId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:read.
     * @summary Lists the company checks waiting to be confirmed.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [verificationStatus] Where the check stands. Empty returns the ones waiting for a manager.
     * @param {string} [responsibleId] Manager responsible for confirming it.
     * @param {string} [agentUserId] Agent the check is about.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListCompanyVerifications(
      paginationPage?: string,
      paginationPerPage?: string,
      verificationStatus?: string,
      responsibleId?: string,
      agentUserId?: string,
      options?: any,
    ): AxiosPromise<V1ListCompanyVerificationsResponse> {
      return localVarFp
        .agentsServiceListCompanyVerifications(
          paginationPage,
          paginationPerPage,
          verificationStatus,
          responsibleId,
          agentUserId,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the agent\'s own comments on one of their deals. Comments written by staff are not shown.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListDealComments(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealCommentsResponse> {
      return localVarFp
        .agentsServiceListDealComments(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the investment strategy videos with how far the calling agent has watched each one, so the cabinet can show progress and resume playback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListEducationVideos(options?: any): AxiosPromise<V1ListEducationVideosResponse> {
      return localVarFp
        .agentsServiceListEducationVideos(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the clients the calling agent has brought in, with the same shortened names: where each stands and what happens next, and nothing the company keeps to itself.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyClients(options?: any): AxiosPromise<V1ListMyClientsResponse> {
      return localVarFp
        .agentsServiceListMyClients(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the calling agent\'s own deals. Client names are shortened to a first name and an initial.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyDeals(options?: any): AxiosPromise<V1ListMyDealsResponse> {
      return localVarFp
        .agentsServiceListMyDeals(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the calling agent\'s presentations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyPresentations(options?: any): AxiosPromise<V1ListMyPresentationsResponse> {
      return localVarFp
        .agentsServiceListMyPresentations(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the leads the calling agent has submitted, with the contact details needed to send a presentation to one of them. Only the agent\'s own leads, and only what they told the company themselves.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyReferrals(options?: any): AxiosPromise<V1ListMyReferralsResponse> {
      return localVarFp
        .agentsServiceListMyReferrals(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the calling agent\'s own requests.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [status] State of the request: new, in_progress or closed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListMyTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      options?: any,
    ): AxiosPromise<V1ListTicketsResponse> {
      return localVarFp
        .agentsServiceListMyTickets(paginationPage, paginationPerPage, status, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists partner companies with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [searchQuery] Full-text search over the company name.
     * @param {string} [companyStatus] State of the company.
     * @param {string} [companyType] Kind of company.
     * @param {string} [responsiblePartnerManagerId] Manager on our side responsible for the company.
     * @param {boolean} [includeArchived] Also return archived companies.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPartnerCompanies(
      paginationPage?: string,
      paginationPerPage?: string,
      searchQuery?: string,
      companyStatus?: string,
      companyType?: string,
      responsiblePartnerManagerId?: string,
      includeArchived?: boolean,
      options?: any,
    ): AxiosPromise<V1ListPartnerCompaniesResponse> {
      return localVarFp
        .agentsServiceListPartnerCompanies(
          paginationPage,
          paginationPerPage,
          searchQuery,
          companyStatus,
          companyType,
          responsiblePartnerManagerId,
          includeArchived,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the per-lead links of a presentation, with how often each was opened.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListPresentationShares(
      id: string,
      options?: any,
    ): AxiosPromise<V1ListPresentationSharesResponse> {
      return localVarFp
        .agentsServiceListPresentationShares(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the sales materials of a residential complex the agent is allowed to work with: presentations, brochures, price lists and the rest. The links are short-lived and lead straight to the file.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListProjectMaterials(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<V1ListProjectMaterialsResponse> {
      return localVarFp
        .agentsServiceListProjectMaterials(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators only.
     * @summary Lists the rules that decide who answers which kind of agent request.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListRoutingRules(options?: any): AxiosPromise<V1ListRoutingRulesResponse> {
      return localVarFp
        .agentsServiceListRoutingRules(options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators and the head of sales see every request; a manager sees the ones they are responsible for, are backup for, or have taken.
     * @summary Lists agent requests with filters and paging.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {string} [status] State of the request: new, in_progress or closed.
     * @param {string} [type] Kind of request.
     * @param {boolean} [assignedToMe] Only the requests the caller is responsible for, is backup for, or has taken.
     * @param {string} [agentUserId] Only the requests of this agent.
     * @param {string} [createdFrom] Only requests raised at or after this moment.
     * @param {string} [createdTo] Only requests raised before this moment.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListTickets(
      paginationPage?: string,
      paginationPerPage?: string,
      status?: string,
      type?: string,
      assignedToMe?: boolean,
      agentUserId?: string,
      createdFrom?: string,
      createdTo?: string,
      options?: any,
    ): AxiosPromise<V1ListTicketsResponse> {
      return localVarFp
        .agentsServiceListTickets(
          paginationPage,
          paginationPerPage,
          status,
          type,
          assignedToMe,
          agentUserId,
          createdFrom,
          createdTo,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the training webinars, with whether the calling agent signed up for each and whether they turned up.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceListWebinars(options?: any): AxiosPromise<V1ListWebinarsResponse> {
      return localVarFp
        .agentsServiceListWebinars(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a message from the agent to the conversation about their request.
     * @param {string} ticketId
     * @param {AgentsServicePostAgentTicketMessageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePostAgentTicketMessage(
      ticketId: string,
      body: AgentsServicePostAgentTicketMessageBody,
      options?: any,
    ): AxiosPromise<V1PostAgentTicketMessageResponse> {
      return localVarFp
        .agentsServicePostAgentTicketMessage(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Publishes an edition of the partnership offer in one language. Asking for re-acceptance moves every agent on an older edition to needing to accept the new one, in the same transaction.
     * @param {V1PublishOfferVersionRequest} body One language edition of the offer to publish. The edition number is shared across languages; each language is published separately.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServicePublishOfferVersion(
      body: V1PublishOfferVersionRequest,
      options?: any,
    ): AxiosPromise<V1PublishOfferVersionResponse> {
      return localVarFp
        .agentsServicePublishOfferVersion(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Public, and protected by a captcha instead of a token.  Input problems come back as invalid-argument errors — or already-exists when the email is taken — carrying, per field, the name of the field and a machine-readable reason code. Clients highlight the field and translate the code; the flat message is only a fallback. The codes are: INVALID_VALUE, INVALID_EMAIL, INVALID_PASSWORD, INVALID_PHONE, INVALID_COUNTRY, EMAIL_TAKEN, AGREEMENT_REQUIRED, CAPTCHA_FAILED and OFFER_VERSION_OUTDATED. Internal note: a new code is only added together with its translation key on every client (ADR-0031).
     * @summary Registers a new agent: creates their sign-in credentials, their profile and the record of their accepting the partnership offer. They can sign in once they confirm their email address.
     * @param {V1RegisterRequest} body Everything needed to sign an agent up.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegister(
      body: V1RegisterRequest,
      options?: any,
    ): AxiosPromise<V1RegisterResponse> {
      return localVarFp
        .agentsServiceRegister(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Signs the calling agent up for a webinar.
     * @param {string} webinarId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRegisterForWebinar(
      webinarId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1RegisterForWebinarResponse> {
      return localVarFp
        .agentsServiceRegisterForWebinar(webinarId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replies to an agent in the conversation about their request, optionally taking the request at the same time.
     * @param {string} ticketId
     * @param {AgentsServiceReplyTicketBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceReplyTicket(
      ticketId: string,
      body: AgentsServiceReplyTicketBody,
      options?: any,
    ): AxiosPromise<V1ReplyTicketResponse> {
      return localVarFp
        .agentsServiceReplyTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Asks for a meeting about one of the agent\'s deals. The request goes to the manager of that deal.
     * @param {string} dealId
     * @param {AgentsServiceRequestMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceRequestMeeting(
      dealId: string,
      body: AgentsServiceRequestMeetingBody,
      options?: any,
    ): AxiosPromise<V1RequestMeetingResponse> {
      return localVarFp
        .agentsServiceRequestMeeting(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: it has a path of its own rather than sitting under the company routes, so that the gateway does not treat it as a company identifier.
     * @summary Suggests companies by the beginning of their name, for the agency field on the sign-up form. Public, and returns only an identifier, a name and a city.
     * @param {string} [query] Beginning of the company name. At least two characters.
     * @param {number} [limit] Most suggestions to return. Zero means ten.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSearchPartnerCompanies(
      query?: string,
      limit?: number,
      options?: any,
    ): AxiosPromise<V1SearchPartnerCompaniesResponse> {
      return localVarFp
        .agentsServiceSearchPartnerCompanies(query, limit, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage; special terms are recorded as approved by the caller.
     * @summary Sets how an agent is rewarded: one of the standard shares, or terms agreed specially with them.
     * @param {string} userId
     * @param {AgentsServiceSetAgentCommercialTermsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentCommercialTerms(
      userId: string,
      body: AgentsServiceSetAgentCommercialTermsBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceSetAgentCommercialTerms(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Moves an agent along with respect to the partnership offer: sent, needs accepting again, rejected, suspended or not sent. Acceptance itself is recorded by the agent accepting it, never set here.
     * @param {string} userId
     * @param {AgentsServiceSetAgentOfferStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentOfferStatus(
      userId: string,
      body: AgentsServiceSetAgentOfferStatusBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceSetAgentOfferStatus(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Moves an agent along in their life with the company: approves them, marks them dormant, or archives them. The early states are set by the sign-up and onboarding flows rather than here, and blocking is a separate matter.
     * @param {string} userId
     * @param {AgentsServiceSetAgentStatusBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetAgentStatus(
      userId: string,
      body: AgentsServiceSetAgentStatusBody,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceSetAgentStatus(userId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: право clients:assign_agent; агент должен быть в статусе active, иначе FailedPrecondition. Снятие агента делается через client-data UpdateClient.client_source_type (DEV-1910), а не этим RPC.
     * @summary Назначает или меняет агента-источника у клиента из CRM (DEV-1912, ADR-0051): agents собирает снимки профиля агента (имя, компания, модель участия, процент вознаграждения) и передаёт их в client-data, где хранится привязка. Повтор того же агента идемпотентен: снимки обновляются, событий и уведомлений нет. Новому агенту уходит уведомление client_attached со ссылкой на карточку клиента в его кабинете.
     * @param {string} clientId
     * @param {AgentsServiceSetClientAgentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetClientAgent(
      clientId: string,
      body: AgentsServiceSetClientAgentBody,
      options?: any,
    ): AxiosPromise<V1SetClientAgentResponse> {
      return localVarFp
        .agentsServiceSetClientAgent(clientId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators only.
     * @summary Switches a routing rule on or off without deleting it.
     * @param {string} id
     * @param {AgentsServiceSetRoutingRuleEnabledBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSetRoutingRuleEnabled(
      id: string,
      body: AgentsServiceSetRoutingRuleEnabledBody,
      options?: any,
    ): AxiosPromise<V1RoutingRuleResponse> {
      return localVarFp
        .agentsServiceSetRoutingRuleEnabled(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a link to a presentation for one particular lead, so that views can be counted per person. Sharing the same presentation with the same lead again returns the link that already exists.
     * @param {string} id
     * @param {AgentsServiceSharePresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSharePresentation(
      id: string,
      body: AgentsServiceSharePresentationBody,
      options?: any,
    ): AxiosPromise<V1PresentationShare> {
      return localVarFp
        .agentsServiceSharePresentation(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Raises a request that is not about any particular deal: a general question or one about how to sell. It is routed by the kind of question.
     * @param {V1SubmitInquiryRequest} body A question that is not about any particular deal.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitInquiry(
      body: V1SubmitInquiryRequest,
      options?: any,
    ): AxiosPromise<V1SubmitInquiryResponse> {
      return localVarFp
        .agentsServiceSubmitInquiry(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Submits a lead: the agent tells the company about a client they have found, and the claim on that client is fixed for a period.
     * @param {V1SubmitLeadRequest} body The lead the agent is submitting.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceSubmitLead(
      body: V1SubmitLeadRequest,
      options?: any,
    ): AxiosPromise<V1SubmitLeadResponse> {
      return localVarFp
        .agentsServiceSubmitLead(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Takes a request: the caller becomes the person working on it.
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTakeTicket(
      ticketId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1TicketActionResponse> {
      return localVarFp
        .agentsServiceTakeTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Progress counts the stretches of the timeline actually played, not the cursor position: dragging the scrubber to the end does not complete a video. Stretches are clamped to the real duration, as they arrive from the browser.
     * @summary Records a batch of playback events and returns the recalculated progress.
     * @param {string} videoId
     * @param {AgentsServiceTrackEducationVideoBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTrackEducationVideo(
      videoId: string,
      body: AgentsServiceTrackEducationVideoBody,
      options?: any,
    ): AxiosPromise<V1TrackEducationVideoResponse> {
      return localVarFp
        .agentsServiceTrackEducationVideo(videoId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Passes a request on to whoever is next in line for it.
     * @param {string} ticketId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceTransferTicket(
      ticketId: string,
      body: object,
      options?: any,
    ): AxiosPromise<V1TicketActionResponse> {
      return localVarFp
        .agentsServiceTransferTicket(ticketId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes a presentation: the complex, the language, the title or the note. The captured text and the printable copy are rebuilt, but the link stays the same, so a client who already has it sees the new version.
     * @param {string} id
     * @param {AgentsServiceUpdateMyPresentationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyPresentation(
      id: string,
      body: AgentsServiceUpdateMyPresentationBody,
      options?: any,
    ): AxiosPromise<V1AgentPresentation> {
      return localVarFp
        .agentsServiceUpdateMyPresentation(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Changes the parts of their own profile an agent is allowed to change: where they are, how to reach them, and their business card.
     * @param {V1UpdateMyProfileRequest} body The parts of their own profile an agent may change. An empty string leaves a field as it is.  The phone number is deliberately absent: it identifies the agent for sign-up, deduplication and routing, so changing it goes through a manager.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateMyProfile(
      body: V1UpdateMyProfileRequest,
      options?: any,
    ): AxiosPromise<V1AgentProfile> {
      return localVarFp
        .agentsServiceUpdateMyProfile(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: requires agents:manage.
     * @summary Changes a partner company.
     * @param {string} id
     * @param {AgentsServiceUpdatePartnerCompanyBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdatePartnerCompany(
      id: string,
      body: AgentsServiceUpdatePartnerCompanyBody,
      options?: any,
    ): AxiosPromise<V1PartnerCompanyResponse> {
      return localVarFp
        .agentsServiceUpdatePartnerCompany(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: administrators only.
     * @summary Changes a routing rule.
     * @param {string} id
     * @param {AgentsServiceUpdateRoutingRuleBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    agentsServiceUpdateRoutingRule(
      id: string,
      body: AgentsServiceUpdateRoutingRuleBody,
      options?: any,
    ): AxiosPromise<V1RoutingRuleResponse> {
      return localVarFp
        .agentsServiceUpdateRoutingRule(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AgentsServiceApi - object-oriented interface
 * @export
 * @class AgentsServiceApi
 * @extends {BaseAPI}
 */
export class AgentsServiceApi extends BaseAPI {
  /**
   * Internal note: requires agents:manage.
   * @summary Archives a partner company. Companies are never deleted, because agents and deals refer to them; the built-in \"private agent\" record cannot even be archived.
   * @param {string} id
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceArchivePartnerCompany(
    id: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceArchivePartnerCompany(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Answers when the reward on one of the agent\'s deals will be paid. If the date is not settled yet, raises a request about it instead and says so.
   * @param {string} dealId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceAskCommission(dealId: string, body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceAskCommission(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: a manager may only take an agent for themselves; administrators and the head of sales may assign anyone.
   * @summary Puts an agent in the care of a manager, or takes them out of it.
   * @param {string} userId
   * @param {AgentsServiceAssignAgentManagerBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceAssignAgentManager(
    userId: string,
    body: AgentsServiceAssignAgentManagerBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceAssignAgentManager(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Answers whether a phone number belongs to a client the company already knows, before the agent submits the lead. Nothing about a matching client is revealed.
   * @param {V1CheckLeadUniqueRequest} body Phone number to check against the existing clients.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCheckLeadUnique(
    body: V1CheckLeadUniqueRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCheckLeadUnique(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Closes a request, with a note about how it ended.
   * @param {string} ticketId
   * @param {AgentsServiceCloseTicketBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCloseTicket(
    ticketId: string,
    body: AgentsServiceCloseTicketBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCloseTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:update.
   * @summary Marks a task about an agent done, or puts it back into work.
   * @param {string} userId
   * @param {string} taskId
   * @param {AgentsServiceCompleteAgentTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCompleteAgentTask(
    userId: string,
    taskId: string,
    body: AgentsServiceCompleteAgentTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCompleteAgentTask(userId, taskId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Records which of the suggested companies the agent says is theirs. A manager still confirms it afterwards.
   * @param {V1ConfirmCompanyAssignmentByAgentRequest} body Which of the suggested companies the agent says is theirs.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceConfirmCompanyAssignmentByAgent(
    body: V1ConfirmCompanyAssignmentByAgentRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceConfirmCompanyAssignmentByAgent(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Settles a company check: accepts what the agent chose, records them as a private agent, or names a different company with a reason.
   * @param {string} id
   * @param {AgentsServiceConfirmCompanyAssignmentByManagerBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceConfirmCompanyAssignmentByManager(
    id: string,
    body: AgentsServiceConfirmCompanyAssignmentByManagerBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceConfirmCompanyAssignmentByManager(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Creates an agent by hand, before they have signed up themselves: their sign-in credentials are made ready and their profile is filled in from what the manager knows. Duplicates are caught by phone, email and Telegram.
   * @param {V1CreateAgentRequest} body An agent created by hand, before they have signed up themselves.  The email address is required, because sign-in credentials are made ready for them, and a company is required as well: an agent working on their own is recorded against the built-in \&quot;private agent\&quot; company rather than against none.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateAgent(body: V1CreateAgentRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateAgent(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:update.
   * @summary Creates a task about an agent: a meeting, a follow-up, or something else.
   * @param {string} userId
   * @param {AgentsServiceCreateAgentTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateAgentTask(
    userId: string,
    body: AgentsServiceCreateAgentTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateAgentTask(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a comment from the agent to one of their own clients, and tells the manager responsible for that client about it.
   * @param {string} clientId
   * @param {AgentsServiceCreateClientCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateClientComment(
    clientId: string,
    body: AgentsServiceCreateClientCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateClientComment(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a comment from the agent to one of their own deals, and tells the manager of that deal about it.
   * @param {string} dealId
   * @param {AgentsServiceCreateDealCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateDealComment(
    dealId: string,
    body: AgentsServiceCreateDealCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateDealComment(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Books a task into a free slot of the manager of one of the agent\'s deals. A slot that has been taken in the meantime is refused rather than double-booked.
   * @param {string} dealId
   * @param {AgentsServiceCreateDealTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateDealTask(
    dealId: string,
    body: AgentsServiceCreateDealTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateDealTask(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Builds a presentation of one residential complex for the calling agent: a page they can send to a client, carrying their own business card and no company branding. The printable copy is produced afterwards.
   * @param {V1CreateMyPresentationRequest} body The presentation to build.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateMyPresentation(
    body: V1CreateMyPresentationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateMyPresentation(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Adds a partner company to the register.
   * @param {V1CreatePartnerCompanyRequest} body A new partner company. Fields that read like enumerations are strings, and an empty one means the default named below.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreatePartnerCompany(
    body: V1CreatePartnerCompanyRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreatePartnerCompany(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators only.
   * @summary Adds a routing rule.
   * @param {V1CreateRoutingRuleRequest} body A new routing rule.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateRoutingRule(
    body: V1CreateRoutingRuleRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateRoutingRule(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Publishes a webinar for agents to sign up to.
   * @param {V1CreateWebinarRequest} body A new webinar.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceCreateWebinar(body: V1CreateWebinarRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceCreateWebinar(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Disconnects the calling agent from the Telegram bot.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceDeleteAgentBotLink(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceDeleteAgentBotLink(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a presentation. Its link stops resolving.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceDeleteMyPresentation(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceDeleteMyPresentation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators only.
   * @summary Deletes a routing rule.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceDeleteRoutingRule(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceDeleteRoutingRule(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note on route order: this catch-all must stay the first GET declared in the service. The gateway prepends routes as they are registered and does not prefer literal segments, so whatever is declared later matches first. Declaring the wildcard first puts it last in the chain, which is what lets the literal /agents/... routes below match at all. Never add a static GET under /agents/ above this method (DEV-509).
   * @summary Returns one agent\'s profile.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgent(userId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgent(userId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a single-use code and a link that connect the calling agent to the Telegram bot.
   * @param {object} body Empty: the code is issued for the calling agent.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentBotLinkCode(body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentBotLinkCode(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns whether the calling agent is connected to the Telegram bot.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentBotStatus(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentBotStatus(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the headline numbers of the calling agent\'s own dashboard: clients brought in, deals in progress, deposits paid, the forecast reward, when they last did anything and what is due next.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentDashboard(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentDashboard(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: a manager sees the agents they look after, the head of sales and administrators see all of them. On route order — this wildcard must stay above the agent\'s own /agents/me/deals of the same length, or it will swallow it (DEV-509).
   * @summary Returns one agent\'s deals as staff see them: real client names, unlike the agent\'s own view, together with what has been earned and what is due.
   * @param {string} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentDeals(userId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentDeals(userId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:read. Managers see their own agents, ADMIN and HOS see everyone.
   * @summary Returns one agent\'s progress through the training catalogue, for their card in the CRM.
   * @param {string} agentUserId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentEducationProgress(
    agentUserId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentEducationProgress(agentUserId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:read; a manager sees the agents they look after.
   * @summary Returns the work journal: every agent together with the meetings and follow-ups held with them over a period.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [periodFrom] Start of the window the meetings and follow-ups are counted over. Absent means from the beginning.  The register of agents itself is deliberately not cut by the period: a journal for one month would otherwise lose the agents signed up earlier who are exactly the ones being worked with now. When each agent first appeared is visible in their own record.
   * @param {string} [periodTo] End of that window. Absent means up to now.
   * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
   * @param {string} [agentStatus] Where the agent stands.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetAgentsWorkReport(
    paginationPage?: string,
    paginationPerPage?: string,
    periodFrom?: string,
    periodTo?: string,
    managerId?: string,
    agentStatus?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetAgentsWorkReport(
        paginationPage,
        paginationPerPage,
        periodFrom,
        periodTo,
        managerId,
        agentStatus,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:read.
   * @summary Returns one company check.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetCompanyVerification(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetCompanyVerification(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns when the manager of one of the agent\'s deals is free, so a meeting can be booked into a slot that is actually open.
   * @param {string} dealId
   * @param {string} [from] Start of the window. Optional.
   * @param {string} [to] End of the window. Optional.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetDealFreeSlots(
    dealId: string,
    from?: string,
    to?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetDealFreeSlots(dealId, from, to, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Returns per-video training figures: how many agents started, how many finished, and the retention curve showing where people drop off.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetEducationVideoStats(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetEducationVideoStats(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the calling agent\'s own company check: which companies were suggested for the name they typed, and where the check stands.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyCompanyVerification(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyCompanyVerification(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one of the calling agent\'s presentations.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyPresentation(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyPresentation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the profile of the agent making the call.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyProfile(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyProfile(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one of the calling agent\'s own requests, with the conversation about it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetMyTicket(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetMyTicket(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Public, like registration — the offer has to be readable before signing up. Internal note: declared below the catch-all above, for the route ordering explained there.
   * @summary Returns the partnership offer: the current edition, or a named one. The language comes from the request header, falling back to Russian.
   * @param {number} [version] Zero, the default, returns the current edition. A number returns that edition, which is how an agent re-reads the one they accepted.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetOffer(version?: number, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetOffer(version, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one partner company.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetPartnerCompany(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetPartnerCompany(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the presentation behind a public link, for the page a client opens. Public, and counts the view.
   * @param {string} token
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetPublicPresentation(token: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetPublicPresentation(token, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the same kind of code for a member of staff, so that they receive agent notifications in the bot.
   * @param {object} body Empty: the code is issued for the calling member of staff.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetStaffBotLinkCode(body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetStaffBotLinkCode(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one request with its history and the conversation about it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceGetTicket(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceGetTicket(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:read; a manager sees the agents they look after.
   * @summary Lists the tasks about one agent.
   * @param {string} userId
   * @param {string} [statusFilter] Which tasks to return: open, done, or all of them when empty.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListAgentTasks(
    userId: string,
    statusFilter?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListAgentTasks(userId, statusFilter, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators and the head of sales see every agent; a manager sees the ones they look after.
   * @summary Lists agents with filters and paging.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [searchQuery] Full-text search over the agent\&#39;s name.
   * @param {string} [managerId] Manager who looks after the agent. A caller who may only see their own agents has this set to themselves regardless of what they send.
   * @param {string} [country] Country of the agent, as a two-letter code.
   * @param {string} [language]
   * @param {string} [agentStatus] Where the agent stands.
   * @param {string} [companyId]
   * @param {string} [companyAssignmentStatus] How the company was decided. The requires_verification value is what \&quot;company not confirmed yet\&quot; means.
   * @param {string} [sourceGroup] Broad channel the agent came through.
   * @param {string} [registeredFrom] Only agents registered at or after this moment.
   * @param {string} [registeredTo] Only agents registered before this moment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListAgents(
    paginationPage?: string,
    paginationPerPage?: string,
    searchQuery?: string,
    managerId?: string,
    country?: string,
    language?: string,
    agentStatus?: string,
    companyId?: string,
    companyAssignmentStatus?: string,
    sourceGroup?: string,
    registeredFrom?: string,
    registeredTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListAgents(
        paginationPage,
        paginationPerPage,
        searchQuery,
        managerId,
        country,
        language,
        agentStatus,
        companyId,
        companyAssignmentStatus,
        sourceGroup,
        registeredFrom,
        registeredTo,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the agent\'s own comments on one of their clients. Comments written by staff are not shown.
   * @param {string} clientId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListClientComments(clientId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListClientComments(clientId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:read.
   * @summary Lists the company checks waiting to be confirmed.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [verificationStatus] Where the check stands. Empty returns the ones waiting for a manager.
   * @param {string} [responsibleId] Manager responsible for confirming it.
   * @param {string} [agentUserId] Agent the check is about.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListCompanyVerifications(
    paginationPage?: string,
    paginationPerPage?: string,
    verificationStatus?: string,
    responsibleId?: string,
    agentUserId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListCompanyVerifications(
        paginationPage,
        paginationPerPage,
        verificationStatus,
        responsibleId,
        agentUserId,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the agent\'s own comments on one of their deals. Comments written by staff are not shown.
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListDealComments(dealId: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListDealComments(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the investment strategy videos with how far the calling agent has watched each one, so the cabinet can show progress and resume playback.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListEducationVideos(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListEducationVideos(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the clients the calling agent has brought in, with the same shortened names: where each stands and what happens next, and nothing the company keeps to itself.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyClients(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyClients(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the calling agent\'s own deals. Client names are shortened to a first name and an initial.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyDeals(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyDeals(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the calling agent\'s presentations.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyPresentations(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyPresentations(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the leads the calling agent has submitted, with the contact details needed to send a presentation to one of them. Only the agent\'s own leads, and only what they told the company themselves.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyReferrals(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyReferrals(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the calling agent\'s own requests.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [status] State of the request: new, in_progress or closed.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListMyTickets(
    paginationPage?: string,
    paginationPerPage?: string,
    status?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListMyTickets(paginationPage, paginationPerPage, status, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists partner companies with filters and paging.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [searchQuery] Full-text search over the company name.
   * @param {string} [companyStatus] State of the company.
   * @param {string} [companyType] Kind of company.
   * @param {string} [responsiblePartnerManagerId] Manager on our side responsible for the company.
   * @param {boolean} [includeArchived] Also return archived companies.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListPartnerCompanies(
    paginationPage?: string,
    paginationPerPage?: string,
    searchQuery?: string,
    companyStatus?: string,
    companyType?: string,
    responsiblePartnerManagerId?: string,
    includeArchived?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListPartnerCompanies(
        paginationPage,
        paginationPerPage,
        searchQuery,
        companyStatus,
        companyType,
        responsiblePartnerManagerId,
        includeArchived,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the per-lead links of a presentation, with how often each was opened.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListPresentationShares(id: string, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListPresentationShares(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the sales materials of a residential complex the agent is allowed to work with: presentations, brochures, price lists and the rest. The links are short-lived and lead straight to the file.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListProjectMaterials(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListProjectMaterials(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators only.
   * @summary Lists the rules that decide who answers which kind of agent request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListRoutingRules(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListRoutingRules(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators and the head of sales see every request; a manager sees the ones they are responsible for, are backup for, or have taken.
   * @summary Lists agent requests with filters and paging.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {string} [status] State of the request: new, in_progress or closed.
   * @param {string} [type] Kind of request.
   * @param {boolean} [assignedToMe] Only the requests the caller is responsible for, is backup for, or has taken.
   * @param {string} [agentUserId] Only the requests of this agent.
   * @param {string} [createdFrom] Only requests raised at or after this moment.
   * @param {string} [createdTo] Only requests raised before this moment.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListTickets(
    paginationPage?: string,
    paginationPerPage?: string,
    status?: string,
    type?: string,
    assignedToMe?: boolean,
    agentUserId?: string,
    createdFrom?: string,
    createdTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListTickets(
        paginationPage,
        paginationPerPage,
        status,
        type,
        assignedToMe,
        agentUserId,
        createdFrom,
        createdTo,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the training webinars, with whether the calling agent signed up for each and whether they turned up.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceListWebinars(options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceListWebinars(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a message from the agent to the conversation about their request.
   * @param {string} ticketId
   * @param {AgentsServicePostAgentTicketMessageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServicePostAgentTicketMessage(
    ticketId: string,
    body: AgentsServicePostAgentTicketMessageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServicePostAgentTicketMessage(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Publishes an edition of the partnership offer in one language. Asking for re-acceptance moves every agent on an older edition to needing to accept the new one, in the same transaction.
   * @param {V1PublishOfferVersionRequest} body One language edition of the offer to publish. The edition number is shared across languages; each language is published separately.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServicePublishOfferVersion(
    body: V1PublishOfferVersionRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServicePublishOfferVersion(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Public, and protected by a captcha instead of a token.  Input problems come back as invalid-argument errors — or already-exists when the email is taken — carrying, per field, the name of the field and a machine-readable reason code. Clients highlight the field and translate the code; the flat message is only a fallback. The codes are: INVALID_VALUE, INVALID_EMAIL, INVALID_PASSWORD, INVALID_PHONE, INVALID_COUNTRY, EMAIL_TAKEN, AGREEMENT_REQUIRED, CAPTCHA_FAILED and OFFER_VERSION_OUTDATED. Internal note: a new code is only added together with its translation key on every client (ADR-0031).
   * @summary Registers a new agent: creates their sign-in credentials, their profile and the record of their accepting the partnership offer. They can sign in once they confirm their email address.
   * @param {V1RegisterRequest} body Everything needed to sign an agent up.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceRegister(body: V1RegisterRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceRegister(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Signs the calling agent up for a webinar.
   * @param {string} webinarId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceRegisterForWebinar(
    webinarId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceRegisterForWebinar(webinarId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replies to an agent in the conversation about their request, optionally taking the request at the same time.
   * @param {string} ticketId
   * @param {AgentsServiceReplyTicketBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceReplyTicket(
    ticketId: string,
    body: AgentsServiceReplyTicketBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceReplyTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Asks for a meeting about one of the agent\'s deals. The request goes to the manager of that deal.
   * @param {string} dealId
   * @param {AgentsServiceRequestMeetingBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceRequestMeeting(
    dealId: string,
    body: AgentsServiceRequestMeetingBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceRequestMeeting(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: it has a path of its own rather than sitting under the company routes, so that the gateway does not treat it as a company identifier.
   * @summary Suggests companies by the beginning of their name, for the agency field on the sign-up form. Public, and returns only an identifier, a name and a city.
   * @param {string} [query] Beginning of the company name. At least two characters.
   * @param {number} [limit] Most suggestions to return. Zero means ten.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSearchPartnerCompanies(
    query?: string,
    limit?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSearchPartnerCompanies(query, limit, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage; special terms are recorded as approved by the caller.
   * @summary Sets how an agent is rewarded: one of the standard shares, or terms agreed specially with them.
   * @param {string} userId
   * @param {AgentsServiceSetAgentCommercialTermsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetAgentCommercialTerms(
    userId: string,
    body: AgentsServiceSetAgentCommercialTermsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetAgentCommercialTerms(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Moves an agent along with respect to the partnership offer: sent, needs accepting again, rejected, suspended or not sent. Acceptance itself is recorded by the agent accepting it, never set here.
   * @param {string} userId
   * @param {AgentsServiceSetAgentOfferStatusBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetAgentOfferStatus(
    userId: string,
    body: AgentsServiceSetAgentOfferStatusBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetAgentOfferStatus(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Moves an agent along in their life with the company: approves them, marks them dormant, or archives them. The early states are set by the sign-up and onboarding flows rather than here, and blocking is a separate matter.
   * @param {string} userId
   * @param {AgentsServiceSetAgentStatusBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetAgentStatus(
    userId: string,
    body: AgentsServiceSetAgentStatusBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetAgentStatus(userId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: право clients:assign_agent; агент должен быть в статусе active, иначе FailedPrecondition. Снятие агента делается через client-data UpdateClient.client_source_type (DEV-1910), а не этим RPC.
   * @summary Назначает или меняет агента-источника у клиента из CRM (DEV-1912, ADR-0051): agents собирает снимки профиля агента (имя, компания, модель участия, процент вознаграждения) и передаёт их в client-data, где хранится привязка. Повтор того же агента идемпотентен: снимки обновляются, событий и уведомлений нет. Новому агенту уходит уведомление client_attached со ссылкой на карточку клиента в его кабинете.
   * @param {string} clientId
   * @param {AgentsServiceSetClientAgentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetClientAgent(
    clientId: string,
    body: AgentsServiceSetClientAgentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetClientAgent(clientId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators only.
   * @summary Switches a routing rule on or off without deleting it.
   * @param {string} id
   * @param {AgentsServiceSetRoutingRuleEnabledBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSetRoutingRuleEnabled(
    id: string,
    body: AgentsServiceSetRoutingRuleEnabledBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSetRoutingRuleEnabled(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a link to a presentation for one particular lead, so that views can be counted per person. Sharing the same presentation with the same lead again returns the link that already exists.
   * @param {string} id
   * @param {AgentsServiceSharePresentationBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSharePresentation(
    id: string,
    body: AgentsServiceSharePresentationBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSharePresentation(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Raises a request that is not about any particular deal: a general question or one about how to sell. It is routed by the kind of question.
   * @param {V1SubmitInquiryRequest} body A question that is not about any particular deal.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSubmitInquiry(body: V1SubmitInquiryRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSubmitInquiry(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Submits a lead: the agent tells the company about a client they have found, and the claim on that client is fixed for a period.
   * @param {V1SubmitLeadRequest} body The lead the agent is submitting.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceSubmitLead(body: V1SubmitLeadRequest, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceSubmitLead(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Takes a request: the caller becomes the person working on it.
   * @param {string} ticketId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceTakeTicket(ticketId: string, body: object, options?: RawAxiosRequestConfig) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceTakeTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Progress counts the stretches of the timeline actually played, not the cursor position: dragging the scrubber to the end does not complete a video. Stretches are clamped to the real duration, as they arrive from the browser.
   * @summary Records a batch of playback events and returns the recalculated progress.
   * @param {string} videoId
   * @param {AgentsServiceTrackEducationVideoBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceTrackEducationVideo(
    videoId: string,
    body: AgentsServiceTrackEducationVideoBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceTrackEducationVideo(videoId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Passes a request on to whoever is next in line for it.
   * @param {string} ticketId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceTransferTicket(
    ticketId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceTransferTicket(ticketId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes a presentation: the complex, the language, the title or the note. The captured text and the printable copy are rebuilt, but the link stays the same, so a client who already has it sees the new version.
   * @param {string} id
   * @param {AgentsServiceUpdateMyPresentationBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdateMyPresentation(
    id: string,
    body: AgentsServiceUpdateMyPresentationBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdateMyPresentation(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Changes the parts of their own profile an agent is allowed to change: where they are, how to reach them, and their business card.
   * @param {V1UpdateMyProfileRequest} body The parts of their own profile an agent may change. An empty string leaves a field as it is.  The phone number is deliberately absent: it identifies the agent for sign-up, deduplication and routing, so changing it goes through a manager.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdateMyProfile(
    body: V1UpdateMyProfileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdateMyProfile(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: requires agents:manage.
   * @summary Changes a partner company.
   * @param {string} id
   * @param {AgentsServiceUpdatePartnerCompanyBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdatePartnerCompany(
    id: string,
    body: AgentsServiceUpdatePartnerCompanyBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdatePartnerCompany(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: administrators only.
   * @summary Changes a routing rule.
   * @param {string} id
   * @param {AgentsServiceUpdateRoutingRuleBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AgentsServiceApi
   */
  public agentsServiceUpdateRoutingRule(
    id: string,
    body: AgentsServiceUpdateRoutingRuleBody,
    options?: RawAxiosRequestConfig,
  ) {
    return AgentsServiceApiFp(this.configuration)
      .agentsServiceUpdateRoutingRule(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
